import type { TimeLimitIndex, EveEvent, SimVal, RecomsOnCat, Neighbor, NeighborsCat } from "./types/types";
import $, { Event } from "jquery";
import m from "../prime-src/prepare";
import { useEffect, useState } from "react";
import SidebarCon from "./components/SidebarCon";
import RightTop from "./components/RightTop";
import LangList from "./components/LangList";
import FSTimezone from "./components/FSTimezone";
import TimezoneList from "./components/TimezoneList";
import ChangeStyle from "./components/ChangeStyle";
import Foot from "./components/Foot";
import ShortKeys from "./components/ShortKeys";
import GoogleSearch from "./components/GoogleSearch";
import ButtonsHead from "./components/ButtonsHead";
import ContentsRecoms from "./components/ContentsRecoms";
import ButtonsPointRange from "./components/ButtonsPointRange";
import HeadPlay from "./components/HeadPlay";
import Manual from "./components/Manual";
import ContentsRecos from "./components/ContentsRecos";
import FSGotoCats from "./components/FSGotoCats";
import FSGo from "./components/FSGo";
import FSTableOfRecos from "./components/FSTableOfRecos";
import FSMultirecoCats from "./components/FSMultirecoCats";
import ButtonsFloating from "./components/ButtonsFloating";
import Memorizing from "./components/Memorizing";
import FormNewReco from "./components/FormNewReco";
import NotiCopied from "./components/NotiCopied";
import NotiLogOut from "./components/NotiLogOut";
import BlockTouch from "./components/BlockTouch";

window.m = m;

export default function App() {
	const [styles, setStyles] = useState(m.defaultStyles);
	const [blockTouch, setBlockTouch] = useState(false);
	const [myCatList, setMyCatList] = useState(m.myCatListHTMLEscaped.trim());
	const [userCatList, setUserCatList] = useState(m.catListHTMLEscaped.trim());
	const [isChangingOrder, setIsChangingOrder] = useState(false);

	async function initialEffect() {
		/* Prerequisite */
		//////////////////
		// Variables
		//////////////////
		m.$container = $("#container");
		m.$h1 = $("#h1");
		m.$block_touch = $("#block-touch");
		m.$block_touch_exit = $("#block-touch-exit");
		m.$block_touch_exit.trigger("click");
		m.$data_myCatList = $("#data-myCatList");
		m.$data_catList = m.myPage ? m.$data_myCatList : $("#data-catList");
		m.$data_kipid_catList = $("#data-kipid-catList");
		m.$choose_lang = $("#choose-lang");
		m.$choose_lang_list = $("#choose-lang-list");
		m.$data_lang = $("#data-lang");
		m.$choose_timezone = $("#choose-timezone");
		m.$choose_timezone_list = $("#choose-timezone-list");
		m.$search_timezone_container = $("#search-timezone-container");
		m.$search_timezone = $("#search-timezone");
		m.$search_timezone_list = $("#search-timezone-list");

		m.$user_noti = $("#user-noti");
		m.$my_id = $("#my-id");

		m.$new_reco = $("#new-reco");
		m.$new_reco.hide();
		m.$my_reco = $("#my-reco");
		m.$log_out_do_container = $("#log-out-do-container, #log-out-do-exit");
		m.$log_out_do = $("#log-out-do");
		m.$log_out_do_container.hide();
		m.$log_out_do_container.on("click", function (e) {
			m.$log_out_do_container.hide();
		});
		m.$log_out_do.on("click", function (e) {
			e.stopPropagation();
		});

		m.$headPlay = $("#headPlay");
		$("#headPlay-buttons").html(`<div class="button darkgoldenrod" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyQ' })">Preceding(<span class="bold underline">Q</span>)</div>
<div class="button darkgoldenrod" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyW' })">Follo<span class="bold underline">w</span>ing</div>
<div style="display:inline-block">
	<div class="button button-sort" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyS' })">▼ <span class="bold underline">S</span>ort</div>
	<div id="sort-list" style="display:none">
		<div class="button button-sub-sort" onclick="m.doFSToRs('tFirst-desc')">Sort by tFirst, desc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('tFirst-asc')">Sort by tFirst, asc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('tLast-desc')">Sort by tLast, desc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('tLast-asc')">Sort by tLast, asc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('point-desc')">Sort by point, desc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('point-asc')">Sort by point, asc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('title-desc')">Sort by title, desc</div>
		<div class="button button-sub-sort" onclick="m.doFSToRs('title-asc')">Sort by title, asc</div>
		<div class="button button-sub-sort" id="button-save-this-order" style="margin-top:.3em; display:none">Save this order.</div>
		<div id="result-of-change-order" style="display: table; font-size: .7em; width: 100%; max-width: max-content; background: black; color: white"></div>
	</div>
</div>
<div class="button button-sort button-shuffle" onclick="m.doFSToRs('shuffle')">S<span class="bold underline">h</span>uffle</div>
<div class="button enabled button-auto-skip" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyK' })">Auto s<span class="bold underline">k</span>ip</div>
<div class="button button-loop" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyL' })"><span class="bold underline">L</span>oop</div>
<div class="button button-one-loop" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyP' })">One-loo<span class="bold underline">p</span></div>
<div class="button button-ToR" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyT' })"><span class="bold underline">T</span>ofR</div>
<div class="button button-move-all" onclick="m.moveAllTo()">Move filtered all recos in ToRs to the different cats at once.</div>`);
		m.$toggle_reco_list_play = $("#toggle-reco-list-play");
		m.$playlist_container = $("#playlist-container");
		m.$uri_rendered_container = $("#uri-rendered-container");
		m.$eveElse_container = $("#eveElse-container");
		m.$rC_youtube_container = $("#rC-youtube-container");
		m.$eveElse = $("#eveElse");
		m.$youtube = $("#youtube");
		m.$video = $("#video");
		m.$reco_playing = $("#reco-playing");
		m.$button_shuffle = $("#headPlay-buttons .button-shuffle");

		m.$input_uri = $("#input-uri");
		m.$show_URI = $("#show-URI");
		m.$def_titles = $("#def-titles");
		m.$input_title = $("#input-title");
		m.$lyrics_search = $("#lyrics-search");
		m.$lyrics_search.on("click", function (e) {
			window.open(`http://www.google.com/search?q=${encodeURIComponent(m.$input_title.val() + " lyrics genius")}`, "_blank");
		});
		m.$def_cats = $("#def-cats");
		m.$input_cats = $("#input-cats");
		m.$input_cats.attr("placeholder", "Category--Sub category--Subsub category ; Another category ; ...\n[--([\" ' `] is forbidden.)--]");
		m.$formatting_lyrics = $("#formatting-lyrics");
		m.$def_descs = $("#def-descs");
		m.$input_desc = $("#input-desc");
		m.$preview_desc = $("#preview-desc");
		m.$previewed_desc = $("#previewed-desc");
		m.$input_cmt = $("#input-cmt");

		m.$error = $("#error-msg");

		m.$input_val = $(".input-val");
		m.$button_reco = $(".button-reco");
		m.$button_edit = $(".button-edit");
		m.$button_del = $(".button-del");
		m.$button_back = $(".button-back");
		m.$button_close = $(".button-close");
		m.$button_new_reco = $(".button-new-reco");

		m.$out_focus = $("#out-focus");
		m.$fuzzy_search_container = $("#fuzzy-search-container");
		m.$fuzzy_search = $("#fuzzy-search");
		m.$fuzzy_search_list = $("#fuzzy-search-list");
		m.$fuzzy_search_list.on("click.gotoLi", async function (event: Event) {
			await m.gotoLi(event);
		});

		m.$table_of_recos_container = $("#table-of-recos-container");
		m.$table_of_recos = $("#table-of-recos");
		m.$table_of_recos_list = $("#table-of-recos-list");
		m.$table_of_recos_list.on("click.playLi", async function (event) {
			await m.playLi({ target: event.target, byKeyboard: false });
		});

		m.$goto_cats_container = $("#goto-cats-container");
		m.$goto_cats = $("#goto-cats");
		m.$goto_cats_list = $("#goto-cats-list");
		m.$goto_cats_list.on("click.completeCatAndOpenCat", function (event: Event) {
			m.completeCatAndOpenCat(event);
		});

		m.$cat_fs_container = $("#cat-fs-container");
		m.$cat_fs_list = $("#cat-fs-list");

		m.$multireco_cats_container = $("#multireco-cats-container");
		m.$multireco_def_cats = $("#multireco-def-cats");
		m.$multireco_input_cats = $("#multireco-input-cats");
		m.$multireco_cat_fs_container = $("#multireco-cat-fs-container");
		m.$multireco_cat_fs_list = $("#multireco-cat-fs-list");
		m.$multireco_cat_fs_list.on("click.complete-MRCat", function (event) {
			m.completeMRCat({ target: event.target });
		});
		m.$multirecoDefCats = m.$multireco_def_cats.find(".def-cat");
		m.$multirecoReplaceCats = m.$multireco_def_cats.find(".replace-cat");
		m.$multirecoAddTxts = m.$multireco_def_cats.find(".add-txt");
		m.$multirecoDeleteCat = m.$multireco_def_cats.find(".delete-cat");

		m.$show_recos_without_points = $("#show-recos-without-points");
		m.showRWOP = true;
		// RWOP : Reco WithOut Point
		m.$show_only_unrecoed = $("#show-only-unrecoed");

		m.$numbers_of_recos = $(".numbers-of-recos");
		m.$numbers_of_recos0 = $("#numbers-of-recos");

		m.$subCats = $("#subCats");
		m.$contents_recoms = $("#contents-recoms");
		m.$contents = $("#contents");
		m.$scripts = $("#scripts");

		////////////////////////////////////////////////////
		// Language/언어/語言
		////////////////////////////////////////////////////
		m.dataLang = await m.strToJSON(m.$data_lang.html().trim());
		m.changeLang = function (lang, e, elem) {
			m.docCookies.setItem("lang", lang, Infinity, "/");
			// let search = window.location.search;
			// let searchVars = m.getSearchVars(search);
			// if (searchVars["lang"]) {
			// 	searchVars["lang"].val = lang;
			// } else {
			// 	searchVars["lang"] = { key: "lang", val: lang };
			// 	searchVars.push(searchVars["lang"]);
			// }
			let href = m.pathOfCat(m.currentCat, m.recoMode, lang, m.hashURI, m.args);
			if (e?.which === 2) {
				// wheel click.
				$(elem).attr({ href: href });
				return true;
			} else {
				window.location.href = href;
				return false;
			}
		};

		let htmlLangs = "";
		for (let i = 0; i < m.dataLang[0].length; i++) {
			htmlLangs += `<a href="${window.location.pathname}?lang=${m.dataLang[0][i]}" onclick="return m.changeLang('${m.dataLang[0][i]}', event, this)">${m.dataLang[1][i]}</a><br/>`;
		}
		m.$choose_lang_list.prepend(htmlLangs);
		m.$choose_lang.on("click", function (e) {
			if (m.$choose_lang.hasClass("enabled")) {
				m.$choose_lang.removeClass("enabled");
				m.$choose_lang_list.hide();
			} else {
				m.$choose_lang.addClass("enabled");
				m.$choose_lang_list.show();
			}
		});
		m.$choose_timezone.on("click", function (e) {
			if (m.$choose_timezone.hasClass("enabled")) {
				m.$choose_timezone_list.hide();
				m.$search_timezone_container.hide();
				m.$out_focus.trigger("focus");
				m.$choose_timezone.removeClass("enabled");
			} else {
				m.$choose_timezone_list.show();
				m.$search_timezone_container.show();
				m.$search_timezone_container.css({ zIndex: ++m.zIndex });
				m.$search_timezone.trigger("focus");
				m.$choose_timezone.addClass("enabled");
			}
		});
		m.toggleNewReco = function () {
			if (m.$new_reco.is(":visible")) {
				m.$error.scrollTop(m.$error[0].scrollHeight);
				m.$button_new_reco.removeClass("enabled");
				m.$input_uri[0].disabled = true;
				m.$out_focus.trigger("focus");
				m.$new_reco.hide();
				m.newRecoOn = false;
				if (!m.initialOpen && !m.doNotPushHistory) {
					window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
				}
				m.doNotPushHistory = false;
				m.$window.off("scroll.stop");
			} else {
				m.$button_new_reco.addClass("enabled");
				m.$input_uri[0].disabled = false;
				m.$input_uri.on("input.change keyup.change keydown.change cut.change paste.change click.change focus.change", m.input_uriOn);
				m.$new_reco.show();
				m.newRecoOn = true;
				if (!m.initialOpen && !m.doNotPushHistory) {
					window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
				}
				m.doNotPushHistory = false;
				m.$error.scrollTop(m.$error[0].scrollHeight);
				let cat = m.currentCat;
				if (cat && (m.$input_cats.val() === "" || m.$input_title.val() === "" || m.$input_uri.val() === "")) {
					m.$input_cats.val(cat);
				}
				m.wST = m.$window.scrollTop();
				m.$window.off("scroll.stop");
				m.$window.on("scroll.stop", function (e) {
					e.preventDefault();
					e.stopPropagation();
					m.$window.scrollTop(m.wST);
				});
				m.$input_uri.trigger("focus.change");
				m.$input_uri.trigger("keyup.change");
			}
		};

		if (m.myPage) {
			m.$show_only_unrecoed.hide();
		} else {
			m.$show_only_unrecoed.on("click", async function () {
				if (m.$show_only_unrecoed.hasClass("enabled")) {
					m.$show_only_unrecoed.removeClass("enabled");
					m.showOnlyUnrecoed = false;
				} else {
					m.$show_only_unrecoed.addClass("enabled");
					m.showOnlyUnrecoed = true;
				}
				await m.openCat(m.currentCat);
			});
		}

		m.fsScrollToSelected = function (fs, $next) {
			let $fsl = fs.$fsl;
			if ($fsl.is(":visible")) {
				if (!$next?.length) {
					$next = $fsl.find(".selected");
				}
				if ($next.length) {
					$fsl.scrollTop($fsl.scrollTop() + $next.offset().top - $fsl.offset().top - 100);
				}
			}
		};

		m.fsTimezone.$fs = m.$search_timezone;
		m.fsTimezone.$fsl = m.$search_timezone_list;
		m.fsTimezone.$fs_container = m.$search_timezone_container;

		m.fsGotoCats.$fs = m.$goto_cats;
		m.fsGotoCats.$fsl = m.$goto_cats_list;
		m.fsGotoCats.$fs_container = m.$goto_cats_container;

		m.fsCat.$fs = m.$input_cats;
		m.fsCat.$fsl = m.$cat_fs_list;
		m.fsCat.$fs_container = m.$cat_fs_container;

		m.fsMRCat.$fs = m.$multireco_input_cats;
		m.fsMRCat.$fsl = m.$multireco_cat_fs_list;
		m.fsMRCat.$fs_container = m.$multireco_cat_fs_container;

		m.fsGo.$fs = m.$fuzzy_search;
		m.fsGo.$fsl = m.$fuzzy_search_list;
		m.fsGo.$fs_container = m.$fuzzy_search_container;

		m.fsToRs.$fs = m.$table_of_recos;
		m.fsToRs.$fsl = m.$table_of_recos_list;
		m.fsToRs.$fs_container = m.$table_of_recos_container;

		////////////////////////////////////////////////////
		// Floating key
		////////////////////////////////////////////////////
		m.$floating_key = $("#floating-key");
		m.$toggle_floating_key = $("#toggle-floating-key");
		if (m.myPage) {
			$("#button-get-recoms").before(`<div style="position:relative; margin:0 1.5em 2em; float:right; width:70%; padding:1em; background:rgb(200,100,100)"><div id="time-limit" style="position:absolute; left:0; top:0; width:100%; height:100%">
		<div id="time-limit-range" style="position:absolute; left:0px; right:0; height:100%; background:rgb(100,200,100)"></div>
		<div id="time-limit-scroll" style="position:absolute; width:36px; left:-18px; top:0; bottom:0; background:rgba(150,150,150,0.7); border:0.15em solid rgb(50,50,50)"></div>
		<svg width="100%" height="100%" style="overflow:visible">
		<line class="bar" x1="0%" y1="70%" x2="0%" y2="110%"/>
		<line class="bar" x1="16.66666667%" y1="70%" x2="16.66666667%" y2="110%"/>
		<line class="bar" x1="33.33333333%" y1="70%" x2="33.33333333%" y2="110%"/>
		<line class="bar" x1="50%" y1="70%" x2="50%" y2="110%"/>
		<line class="bar" x1="66.66666667%" y1="70%" x2="66.66666667%" y2="110%"/>
		<line class="bar" x1="83.33333333%" y1="70%" x2="83.33333333%" y2="110%"/>
		<line class="bar" x1="100%" y1="70%" x2="100%" y2="110%"/>
		<text class="tick" text-anchor="middle" x="0%" y="150%">No limit
		<tspan text-anchor="middle" x="16.66666667%" y="150%">10 years</tspan>
		<tspan text-anchor="middle" x="33.33333333%" y="150%">1 year</tspan>
		<tspan text-anchor="middle" x="50%" y="150%">1 month</tspan>
		<tspan text-anchor="middle" x="66.66666667%" y="150%">1 week</tspan>
		<tspan text-anchor="middle" x="83.33333333%" y="150%">1 day</tspan>
		<tspan text-anchor="middle" x="100%" y="150%">Now</tspan>
		</text>
		</svg>
		</div></div>`);
			$("#button-get-recoms").replaceWith(`<div class="button button-mode button-get-recoms fLeft" id="button-get-recoms" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyR' })">Get <span class="bold underline">R</span>ecoms</div>
		<div class="button button-mode button-daily-mix fLeft" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyY' })">Dail<span class="bold underline">y</span> Mix Recoms with ToR</div>
		<div class="cBoth"></div>`);
		} else {
			$("#button-get-recoms").replaceWith(`<div class="button button-mode button-get-recoms none" style="display:none" id="button-get-recoms" onclick="m.$window.trigger({ type: 'keydown', code: 'KeyR' })">Get <span class="bold underline">R</span>ecoms</div>`);
		}
		m.$a_log_in = $(".a-log-in");
		m.$a_log_out = $(".a-log-out");
		m.$a_log_out_from_all = $(".a-log-out-from-all");
		m.$a_log_in.on("click mousedown mouseup", m.a_log_in);
		m.$a_log_out.on("click mousedown mouseup", m.a_log_out);
		m.$a_log_out_from_all.on("click mousedown mouseup", m.a_log_out_from_all);
		m.$a_to_my_page = $("#a-to-my-page");
		m.$a_to_my_page.on("click mousedown mouseup", m.a_to_my_page);
		m.$button_hideFK = $("#button-hideFK");
		m.$button_block_touch = $(".button-block-touch");
		m.$button_auto_skip = $(".button-auto-skip");
		m.$button_loop = $(".button-loop");
		m.$button_one_loop = $(".button-one-loop");
		m.$button_Go = $(".button-Go");
		m.$button_ToR = $(".button-ToR");
		m.$button_mode = $(".button-mode");
		m.$button_neighbors_mode = $(".button-neighbors-mode");
		m.$button_multireco_mode = $(".button-multireco-mode");
		m.$sort_list = $("#sort-list");

		if (m.fsToRs.skip) {
			m.$button_auto_skip.addClass("enabled");
		} else {
			m.$button_auto_skip.removeClass("enabled");
		}

		m.$button_get_recoms = $(".button-get-recoms");
		m.$button0_get_recoms = $("#button-get-recoms");
		m.$button_daily_mix = $(".button-daily-mix");
		m.$button_new_reco = $(".button-new-reco");
		m.$button_goto_cats = $(".button-goto-cats");
		m.$time_limit = $("#time-limit");
		m.$time_limit_range = $("#time-limit-range");
		m.$time_limit_scroll = $("#time-limit-scroll");

		m.TL = 0;
		m.lastTLIndex = 0;
		m.TLIndex = 0;
		m.TLinSec = {
			i0: Infinity,
			i1: 10 * 365 * 24 * 60 * 60,
			i2: 365 * 24 * 60 * 60,
			i3: 31 * 24 * 60 * 60,
			i4: 7 * 24 * 60 * 60,
			i5: 24 * 60 * 60,
		};
		m.$window.on("resize.TL", function () {
			m.TLw = m.$time_limit.width();
			m.TLwMax = (m.TLw / 6.0) * 5.0;
		});
		m.$window.trigger("resize.TL");
		m.TLwStepPctg = 100 / 6.0;
		m.mmInTL = function (e) {
			window.getSelection().removeAllRanges();
			e.preventDefault();
			e.stopPropagation();
			clearTimeout(m.timeoutTL);
			let x = e.type === "touchmove" ? (e as TouchEvent).touches[0].clientX : (e as MouseEvent).clientX;
			let w = x - m.$time_limit.offset().left + m.$window.scrollLeft();
			w = w < 0 ? 0 : w;
			w = w > m.TLwMax ? m.TLwMax : w;
			let changed = false;
			if (m.TL !== w) {
				m.TL = w;
				m.$time_limit_range.css({ left: `${m.TL}px` });
				m.$time_limit_scroll.css({ left: `${m.TL - 18}px` });
			}
		};
		m.muInTL = function (e) {
			m.TLIndex = Math.round(((m.TL / m.TLw) * 100) / m.TLwStepPctg) as TimeLimitIndex;
			m.$time_limit_range.css({ left: `${m.TLIndex * m.TLwStepPctg}%` });
			m.$time_limit_scroll.css({ left: `calc(${m.TLIndex * m.TLwStepPctg}% - 18px)` });
			if (m.lastTLIndex !== m.TLIndex) {
				m.timeoutTL = setTimeout(function () {
					m.$button_get_recoms.removeClass("enabled");
					m.$window.trigger({ type: "keydown", code: "KeyR" } as any);
				}, 2 * m.wait);
			}
		};
		m.$time_limit_scroll.on("mousedown.mdPRL touchstart.mdPRL", function () {
			m.$html.on("mousemove.mdInPRL touchmove.mdInPRL", function (e1: Event) {
				m.mmInTL(e1);
			});
			m.$html.on("mouseup.mdInPRL touchend.mdInPRL", function (e2: Event) {
				m.muInTL(e2);
				m.$html.off("mouseup.mdInPRL touchend.mdInPRL mousemove.mdInPRL touchmove.mdInPRL");
			});
		});

		m.$point_range = $(".point-range").eq(0);
		m.$point_range_bar = $(".point-range-bar").eq(0);
		m.$point_range_left = $(".point-range-left").eq(0);
		m.$point_range_right = $(".point-range-right").eq(0);
		// in floating-key
		m.$point_range1 = $(".point-range").eq(1);
		m.$point_range_bar1 = $(".point-range-bar").eq(1);
		m.$point_range_left1 = $(".point-range-left").eq(1);
		m.$point_range_right1 = $(".point-range-right").eq(1);
		m.$point_range_result = $(".point-range-result");

		m.$user_noti.html(m.userId + "'s recos");
		if (m.myIndex) {
			m.$my_id.html(m.myId + " ▾");
		} else {
			m.$my_id.hide();
			m.$button_new_reco.remove();
		}
		if (m.myIndex) {
			m.$a_log_in.hide();
		} else {
			m.$a_log_out.hide();
			m.$a_log_out_from_all.hide();
		}

		m.hideFK = function () {
			m.$floating_key.hide();
			m.docCookies.setItem("hideFK", "y", Infinity, "/", false, true);
		};
		m.toggleFK = function () {
			if (m.$floating_key.is(":visible")) {
				m.docCookies.setItem("hideFK", "y", Infinity, "/", false, true);
			} else {
				m.docCookies.removeItem("hideFK", "/", false, true);
			}
			m.$floating_key.toggle();
		};

		$(".fs-container>.move").each(function (index, elem) {
			let $elem = $(elem);
			$elem.on("mousedown.move touchstart.move", function (e) {
				e.preventDefault();
				e.stopPropagation();
				let touch0 = e.type === "touchstart" ? (e as JQuery.Event).touches[0] : e;
				let relativeX = touch0.clientX - Math.round($elem.offset().left) + m.$window.scrollLeft();
				let relativeY = touch0.clientY - Math.round($elem.offset().top) + m.$window.scrollTop();
				m.$html.on("mousemove.move touchmove.move", function (e) {
					window.getSelection().removeAllRanges();
					e.preventDefault();
					e.stopPropagation();
					let touch0 = e.type === "touchmove" ? (e as JQuery.Event).touches[0] : e;
					$elem.closest(".fs-container").css({
						left: touch0.clientX - relativeX,
						top: touch0.clientY - relativeY,
					});
					m.$html.on("mouseup.move touchend.move", function () {
						m.$html.off("mouseup.move touchend.move mousemove.move touchmove.move");
					});
				});
			});
		});

		m.$timezone_trs = $("table.timezone").find("tr");
		for (let i = m.$timezone_trs.length - 1; i >= 1; i--) {
			let timezoneTxt = m.$timezone_trs
				.eq(i)
				.text()
				.replace(/[\s\r\n\t]+/g, " ")
				.trim();
			m.fsTimezone.fullList.push({
				i: m.$timezone_trs.length - 1 - i,
				txt: m.splitHangul(timezoneTxt),
				html: m.escapeOnlyTag(timezoneTxt),
				timezone: timezoneTxt.substring(0, 9),
			});
		}
		m.timezoneAddMs = 0;
		m.setTimezone = function (elem, timezone: string) {
			const fs = m.fsTimezone;
			fs.$fsLis = fs.$fsl.find(".list-item");
			fs.$fsLis.removeClass("selected");
			let $elem = null;
			if (elem) {
				$elem = $(elem).closest(".list-item");
			}
			if ($elem?.length) {
				$elem.addClass("selected");
				timezone = m.unescapeHTML($elem.find(".list-index-id").html() as string);
			}
			const [addHours, addMinutes] = timezone.substring(3).split(":");
			m.timezoneAddMs = (Number(addHours) * 60 + Number(addMinutes)) * 60 * 1000;
			m.$search_timezone.val(timezone);
			m.docCookies.setItem("timezone", timezone, Infinity, "/", false);
			fs.$fs.trigger("focus");
		};
		m.fsTimezone.$fsl.on("click.fs-timezone", function (e: Event) {
			m.setTimezone(e.target as HTMLElement, "");
		});
		const timezoneOffset = new Date().getTimezoneOffset();
		const timezoneHours = Math.abs(Math.floor(timezoneOffset / 60));
		const timezoneMinutes = Math.abs(timezoneOffset % 60);
		const signTimezone = timezoneOffset > 0 ? "UTC-" : "UTC+";
		const formattedTimezone = `${signTimezone}${String(timezoneHours).padStart(2, "0")}:${String(timezoneMinutes).padStart(2, "0")}`;
		console.log("formattedTimezone: ", formattedTimezone); // "UTC+09:00"과 같이 출력
		if (!m.docCookies.getItem("timezone")) {
			m.docCookies.setItem("timezone", formattedTimezone, Infinity, "/", false);
		}
		m.toLocalTime = function (UTCDateTime) {
			if (UTCDateTime !== undefined && UTCDateTime?.constructor === String) {
				let [datePart, timePart] = UTCDateTime.split(" ");
				let [year, month, day] = datePart.split("-");
				let [hours, minutes, seconds] = timePart.split(":");
				let utcDate = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes), Number(seconds)));
				// Month from 0 base.

				let dateTimeISO = new Date(utcDate.getTime() + m.timezoneAddMs).toISOString();
				// UTC+09:00
				let [dateT, timeT] = dateTimeISO.split("T");
				return `${dateT} ${timeT.substring(0, 8)}`;
			}
			return "";
		};

		///////////////////////////////////////////
		// Fuzzy Search on Table of Recos (ToRs)
		///////////////////////////////////////////
		m.playLi = function (event) {
			return new Promise(async (resolve, reject) => {
				let fs = m.fsToRs;
				if (event?.target?.nodeName !== "A") {
					let $elem = $(event.target);
					if (!$elem.hasClass("list-item")) {
						$elem = $elem.closest(".list-item");
					}
					if (!$elem.length) {
						console.error(`There is no parents(".list-item").`);
						reject(`There is no parents(".list-item").`);
					}
					let k: string | number = $elem[0]?.id?.substring(4);
					if (!isNaN(Number(k))) {
						k = Number(k);
					}
					fs.currentIndex = k;
					if (!m.initialOpen && $elem.hasClass("selected") && !event.byKeyboard) {
						if ($elem.hasClass("clicked-twice")) {
							fs.$fs.trigger({ type: "keydown", code: "Escape" } as any);
							fs.$fsl.find(".list-item").removeClass("clicked-twice");
						} else {
							$elem.addClass("clicked-twice");
						}
					} else {
						try {
							await fs.getAndPlayVideo($elem[0]?.id === fs.$fsl.find(".list-item")[0]?.id && !fs.$fs.val());
							// * (cue, inListPlay = true)
						} catch (err) {
							console.error(err);
						}
						if (!m.initialOpen || !m.initialHashURI) {
							window.location.href = "#playlist-container";
							if (m.fsToRs.$playing?.hasClass("fixed")) {
								m.$window.scrollTop(m.$playlist_container.offset().top - m.fsToRs.$playing?.outerHeight());
							} else {
								m.$window.scrollTop(m.$playlist_container.offset().top);
							}
						}
					}
				}
				await m.reNewAndReOn();
				resolve();
			});
		};
		m.datetimeToMs = function (datetime) {
			return new Date(datetime.replace(/\s/, "T")).getTime();
		};
		m.doFSToRs = function (shuffle) {
			return new Promise(async function (resolve, reject) {
				let fs = m.fsToRs;
				let fsPtnSH = m.splitHangul(fs.$fs.val());
				let shuffled = (fs.shuffled = []);
				let l = fs.fullList.length;
				switch (shuffle) {
					case "shuffle":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: Math.random() };
						}
						break;
					case "tFirst-desc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: -m.datetimeToMs(fs.fullList[i].r.tFirst) };
						}
						break;
					case "tFirst-asc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: m.datetimeToMs(fs.fullList[i].r.tFirst) };
						}
						break;
					case "tLast-desc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: -m.datetimeToMs(fs.fullList[i].r.tLast) };
						}
						break;
					case "tLast-asc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: m.datetimeToMs(fs.fullList[i].r.tLast) };
						}
						break;
					case "point-desc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: -fs.fullList[i].r.val.val };
						}
						break;
					case "point-asc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: fs.fullList[i].r.val.val };
						}
						break;
					case "title-desc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: fs.fullList[i].r.title.toLowerCase() };
						}
						break;
					case "title-asc":
						for (let i = 0; i < l; i++) {
							shuffled[i] = { i, sortN: fs.fullList[i].r.title.toLowerCase() };
						}
						break;
					default:
						for (let i = l - 1; i >= 0; i--) {
							shuffled[l - 1 - i] = { i: l - 1 - i, sortN: i };
							// Desc sorted.
						}
						break;
				}
				if (shuffle === "title-desc") {
					for (let i = 1; i < l; i++) {
						let temp = shuffled[i];
						let j = i;
						for (; j > 0 && shuffled[j - 1].sortN > temp.sortN; j--) {
							shuffled[j] = shuffled[j - 1];
						} // Asc sorting. Stable sort. Largest to the top | the last index.
						shuffled[j] = temp;
					}
				} else {
					for (let i = 1; i < l; i++) {
						let temp = shuffled[i];
						let j = i;
						for (; j > 0 && shuffled[j - 1].sortN < temp.sortN; j--) {
							shuffled[j] = shuffled[j - 1];
						} // Desc sorting. Stable sort. Largest to the bottom | the first index.
						shuffled[j] = temp;
					}
				}
				if (shuffle) {
					fs.shuffledOnce = true;
					m.fsGo.shuffledOnce = true;
				}
				let fsRes = await m.fuzzySearch(fsPtnSH, fs);
				let sorted = fsRes.sorted;
				let str = "";
				for (let i = 0; i < sorted.length; i++) {
					let k = fsRes[sorted[i]].i;
					let fsFLk = fs.fullList[k];
					if (fsFLk.inRange && !fsFLk.r?.deleted) {
						let uri = fsFLk.uri;
						str += `<div id="toR-${k}" class="list-item${fs.currentIndex === k ? " selected" : ""}"><span class="list-index-id">${m.escapeOnlyTag(uri)}</span>${fs.fullList[k].html}${fsRes[sorted[i]].highlight !== undefined ? `<div class="highlighted"><span class="maxMatchScore">${fsRes[sorted[i]].maxMatchScore}</span> :: ${fsRes[sorted[i]].highlight}</div>` : ""}</div>`;
					}
				}
				fs.$fsl.html(str);
				let cat = m.currentCat;
				const recomsCat = m.recoms[cat];
				if (m.recoMode === "daily-mix" && recomsCat && m.recomsPlusRandomSorted[cat]) {
					for (let j = 2 + m.recoedFromRecoms, i = recomsCat.length - 1; i >= 0; j += m.dailyMixPer, i--) {
						fs.$fsLis = fs.$fsl.find(".list-item");
						if (j >= fs.$fsLis.length) {
							j = fs.$fsLis.length - 1;
						}
						let k = m.recomsPlusRandomSorted[cat][i];
						let uri = recomsCat[k].uri;
						let r = m.userRecos[uri];
						let recoDef = m.recoDefs[uri];
						let title = r?.title ? r.title : recoDef?.defTitles?.[0]?.[0] ? recoDef.defTitles[0][0] : "";
						let fsFLFromRecomsK = (fs.fullList[`from-recoms-${k}`] = fs.fullList[uri] = { uri, i: `from-recoms-${k}`, r, txt: m.splitHangul(title), html: m.escapeOnlyTag(title) });
						fs.$fsLis.eq(j).after(`<div id="toR-${fsFLFromRecomsK.i}" class="list-item from-recoms${fs.currentIndex === fsFLFromRecomsK.i ? " selected" : ""}"><span class="list-index-id">${m.escapeOnlyTag(uri)}</span>${fsFLFromRecomsK.html}</div>`);
					}
				}
				setTimeout(function () {
					if (shuffle) {
						fs.shuffledOnce = true;
						m.fsGo.shuffledOnce = true;
					}
					if (m.initialOpen || fs.shuffledOnce || m.lastCat !== m.currentCat) {
						fs.lastIndex = -2;
						let $toR0 = fs.$fsl.find(".list-item").eq(0);
						if ($toR0.length) {
							$toR0.trigger("click");
							m.fsScrollToSelected(fs, $toR0);
						} else {
							if (m.setTimeoutPlayNextFirstCount === undefined || m.setTimeoutPlayNextFirstCount >= m.initialMaxTries) {
								m.setTimeoutPlayNextFirstCount = 0;
							}
							clearTimeout(m.setTimeoutPlayNextFirst);
							m.setTimeoutPlayNextFirstClickedOnce = false;
							m.setTimeoutPlayNextFirst = setTimeout(function selfPlayNextFirst() {
								console.log("selfPlayNextFirst();");
								m.setTimeoutPlayNextFirstCount++;
								fs.$fsLis = fs.$fsl.find(".list-item");
								let $toR0 = fs.$fsLis.eq(0);
								if ($toR0.length) {
									$toR0.trigger("click");
									m.fsScrollToSelected(fs, $toR0);
									m.setTimeoutPlayNextFirstCount = 0;
								} else if (m.setTimeoutPlayNextFirstCount < m.initialMaxTries) {
									setTimeout(selfPlayNextFirst, m.wait);
								} else {
									m.$numbers_of_recos.html(`Cat=${m.currentCat} may not exist, or have no reco to be shown in your point range setting.`);
									console.log("PlayNextFirst has failed.");
									m.setTimeoutPlayNextFirstCount = 0;
								}
							}, m.wait);
						}
					} else if (m.recoMode === "" || m.recoMode === "daily-mix") {
						if (m.lastRecoURIPlaying !== m.recoURIPlaying) {
							let $toRK = $(`#toR-${fs.currentIndex}`);
							if ($toRK.length) {
								$toRK.trigger("click");
							} else {
								if (m.setTimeoutPlayNextFirst1Count === undefined || m.setTimeoutPlayNextFirst1Count >= m.initialMaxTries) {
									m.setTimeoutPlayNextFirst1Count = 0;
								}
								clearTimeout(m.setTimeoutPlayNextFirst1);
								m.setTimeoutPlayNextFirst1 = setTimeout(function selfPlayNextFirst1() {
									console.log("selfPlayNextFirst1();");
									m.setTimeoutPlayNextFirst1Count++;
									let $toRK = $(`#toR-${fs.currentIndex}`);
									if ($toRK.length) {
										$toRK.trigger("click");
										m.fsScrollToSelected(fs, $toRK);
										m.setTimeoutPlayNextFirst1Count = 0;
									} else if (m.setTimeoutPlayNextFirst1Count < m.initialMaxTries) {
										setTimeout(selfPlayNextFirst1, m.wait);
									} else {
										m.$numbers_of_recos.html(`Cat=${m.currentCat} may not exist, or have no reco to be shown in your point range setting.`);
										console.log("PlayNextFirst1 has failed.");
										m.setTimeoutPlayNextFirst1Count = 0;
									}
								}, m.wait);
							}
						}
					}
					if (m.$table_of_recos_container.is(":visible")) {
						m.args.TofR = m.$table_of_recos.val();
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					}
					fs.shuffledOnce = false;
					resolve();
				}, m.wait / 2);
			});
		};
		m.fsTofROn = function () {
			return new Promise(async function (resolve, reject) {
				let now = Date.now();
				let passed = now - m.previous;
				if (passed > m.wait) {
					m.previous = now;
					try {
						await m.doFSToRs();
					} catch (err) {
						console.error(err);
					}
					resolve();
				} else {
					m.$table_of_recos.off("keyup.fs cut.fs paste.fs click.fs");
					setTimeout(async function () {
						m.$table_of_recos.on("keyup.fs cut.fs paste.fs click.fs", m.fsTofROn);
						m.previous = Date.now();
						try {
							await m.doFSToRs();
						} catch (err) {
							console.error(err);
						}
						resolve();
					}, m.wait * 1.5 - passed);
				}
			});
		};
		m.fsToRs.fsOn = m.fsTofROn;
		m.reNewFSsOn = function () {
			return new Promise(async function (resolve, reject) {
				m.$fuzzy_search.off("keyup.fs cut.fs paste.fs click.fs");
				m.$table_of_recos.off("keyup.fs cut.fs paste.fs click.fs");
				m.$input_cats.off("keyup.fs cut.fs paste.fs click.fs");
				m.$multireco_input_cats.off("keyup.fs cut.fs paste.fs click.fs");
				m.$search_timezone.off("keyup.fs cut.fs paste.fs click.fs");
				m.$goto_cats.off("keyup.fs cut.fs paste.fs click.fs");

				m.$fuzzy_search.on("keyup.fs cut.fs paste.fs click.fs", m.fsGoOn);
				m.$table_of_recos.on("keyup.fs cut.fs paste.fs click.fs", m.fsTofROn);
				m.$input_cats.on("keyup.fs cut.fs paste.fs click.fs", m.fsCatOn);
				m.$multireco_input_cats.on("keyup.fs cut.fs paste.fs click.fs", m.fsMRCatOn);
				m.$search_timezone.on("keyup.fs cut.fs paste.fs click.fs", m.fsTimezoneOn);
				m.$goto_cats.on("keyup.fs cut.fs paste.fs click.fs", async function () {
					await m.fsGotoCatsOn();
					resolve();
				});

				if (m.initialOpen) {
					await m.reTriggerFS(m.fsGo);
					await m.reTriggerFS(m.fsCat);
					await m.reTriggerFS(m.fsMRCat);
					await m.reTriggerFS(m.fsTimezone);
					await m.reTriggerFS(m.fsToRs);
					await m.reTriggerFS(m.fsGotoCats);
				}
				resolve();
			});
		};

		m.doFSCat = function (fs) {
			return new Promise(async function (resolve, reject) {
				let catsTxt = fs.$fs.val();
				let sEnd = fs.$fs[0].selectionEnd;
				fs.catsSplit = catsTxt.split(";");
				let l = catsTxt.length;
				fs[0].k = 0;
				for (let i = fs.catsSplit.length - 1; i >= 0; i--) {
					l -= fs.catsSplit[i].length + 1;
					if (l < sEnd) {
						fs[0].k = i;
						break;
					}
				} // Picking cat index k of the current selectionEnd.
				let fsCatSH = m.splitHangul(fs.catsSplit[fs[0].k].trim());
				let fsRes = await m.fuzzySearch(fsCatSH, fs);
				let str = "";
				if (fs === m.fsGotoCats) {
					for (let i = 0; i < fsRes.length; i++) {
						let fsSortedI = fsRes[fsRes.sorted[i]];
						let k = fsSortedI.i;
						let fsFLk = fs.fullList[k];
						fsFLk = fs.fullList[k] = fs.fullList[fsFLk?.cat];
						str += `<div class="list-item${fsFLk?.cat === m.currentCat ? " selected" : ""}${fsFLk?.down ? " down" : ""}${fsFLk?.deleted ? " deleted" : ""}" id="gotoCats-${k}"><span class="list-index-id">${m.escapeOnlyTag(fsFLk.cat)}</span>${fs.fullList[fsSortedI.i].html}${fsSortedI.highlight !== undefined ? `<div class="highlighted"><span class="maxMatchScore">${fsSortedI.maxMatchScore}</span> :: ${fsSortedI.highlight}</div>` : ""}</div>`;
						let $catI = $(`#cat-${m.escapeEncodePctg(encodeURIComponent(fsFLk?.cat))}`);
						if ($catI.length) {
							if (fsFLk?.down) {
								$catI.find(".baseCat").addClass("down");
							}
							if (fsFLk?.deleted) {
								$catI.find(".baseCat").addClass("deleted");
							}
						}
					}
				} else if (fs === m.fsCat) {
					for (let i = 0; i < fsRes.length; i++) {
						let fsSortedI = fsRes[fsRes.sorted[i]];
						str += `<div class="list-item${fs.fullList[fsSortedI.i].selected ? " selected" : ""}" onclick="m.completeCat(event)"><span class="list-index-id">${m.escapeOnlyTag(fs.fullList[fsSortedI.i].cat)}</span>${fs.fullList[fsSortedI.i].html}${fsSortedI.highlight !== undefined ? `<div class="highlighted"><span class="maxMatchScore">${fsSortedI.maxMatchScore}</span> :: ${fsSortedI.highlight}</div>` : ""}</div>`;
					}
				} else if (fs === m.fsMRCat) {
					for (let i = 0; i < fsRes.length; i++) {
						let fsSortedI = fsRes[fsRes.sorted[i]];
						str += `<div class="list-item${fs.fullList[fsSortedI.i].selected ? " selected" : ""}"><span class="list-index-id">${m.escapeOnlyTag(fs.fullList[fsSortedI.i].cat)}</span>${fs.fullList[fsSortedI.i].html}${fsSortedI.highlight !== undefined ? `<div class="highlighted"><span class="maxMatchScore">${fsSortedI.maxMatchScore}</span> :: ${fsSortedI.highlight}</div>` : ""}</div>`;
					}
				}
				fs.$fsl.html(str);
				fs.$fsLis = fs.$fsl.find(".list-item");
				if (fs === m.fsGotoCats) {
					for (let i = 0; i < fsRes.length; i++) {
						let fsSortedI = fsRes[fsRes.sorted[i]];
						let fsFLk = fs.fullList[fsSortedI.i];
						let $gotoCatI = $(`#gotoCats-${fsFLk.i}`);
						if ($gotoCatI.length) {
							if (fsFLk?.down) {
								$gotoCatI.addClass("down");
							}
						}
					}
				}
				resolve(str);
			});
		};
		m.doMRFSCat = async function () {
			return await m.doFSCat(m.fsMRCat);
		};
		m.doFSGotoCats = async function () {
			return await m.doFSCat(m.fsGotoCats);
		};
		m.doFSTimezone = function () {
			return new Promise(async (resolve, reject) => {
				let fs = m.fsTimezone;
				fs.$fs.trigger("focus");
				let fsRes = await m.fuzzySearch(m.splitHangul(fs.$fs.val()), fs);
				let str = "";
				for (let i = 0; i < fsRes.length; i++) {
					let fsSortedI = fsRes[fsRes.sorted[i]];
					str += `<div class="list-item${fs.fullList[fsSortedI.i].selected ? " selected" : ""}"><div class="list-index">${fsSortedI.i}</div><div class="list-index-id">${m.escapeOnlyTag(fs.fullList[fsSortedI.i].timezone)}</div>${fs.fullList[fsSortedI.i].html}${fsSortedI.highlight !== undefined ? `<div class="highlighted"><span class="maxMatchScore">${fsSortedI.maxMatchScore}</span> :: ${fsSortedI.highlight}</div>` : ""}</div>`;
				}
				fs.$fsl.html(str);
				fs.$fsLis = fs.$fsl.find(".list-item");
				resolve();
			});
		};

		m.fsCatOn = function (event) {
			return new Promise(async (resolve, reject) => {
				let now = Date.now();
				let passed = now - m.previous;
				if (passed > m.wait) {
					m.previous = now;
					if ((event as EveEvent).code !== "Escape") {
						m.fsCat.$fs_container.show();
					}
					try {
						await m.doFSCat(m.fsCat);
					} catch (err) {
						console.error(err);
					}
					resolve();
				} else {
					m.$input_cats.off("keyup.fs cut.fs paste.fs click.fs");
					setTimeout(async function () {
						m.$input_cats.on("keyup.fs cut.fs paste.fs click.fs", m.fsCatOn);
						m.previous = Date.now();
						if ((event as EveEvent).code !== "Escape") {
							m.fsCat.$fs_container.show();
						}
						try {
							await m.doFSCat(m.fsCat);
						} catch (err) {
							console.error(err);
						}
						resolve();
					}, m.wait * 1.5 - passed);
				}
			});
		};
		m.fsMRCatOn = async function (event) {
			let now = Date.now();
			let passed = now - m.previous;
			if (passed > m.wait) {
				m.previous = now;
				if ((event as EveEvent).code !== "Escape") {
					m.fsMRCat.$fs_container.show();
				}
				m.doMRFSCat();
			} else {
				m.$multireco_input_cats.off("keyup.fs cut.fs paste.fs click.fs");
				setTimeout(function () {
					m.$multireco_input_cats.on("keyup.fs cut.fs paste.fs click.fs", m.fsMRCatOn);
					m.previous = Date.now();
					if ((event as EveEvent).code !== "Escape") {
						m.fsMRCat.$fs_container.show();
					}
					m.doMRFSCat();
				}, m.wait * 1.5 - passed);
			}
		};
		m.fsGotoCatsOn = function () {
			return new Promise(async function (resolve, reject) {
				let now = Date.now();
				let passed = now - m.previous;
				if (passed > m.wait) {
					m.previous = now;
					try {
						await m.doFSGotoCats();
					} catch (err) {
						console.error(err);
					}
					resolve();
				} else {
					m.$goto_cats.off("keyup.fs cut.fs paste.fs click.fs");
					setTimeout(async function () {
						m.$goto_cats.on("keyup.fs cut.fs paste.fs click.fs", m.fsGotoCatsOn);
						m.previous = Date.now();
						try {
							await m.doFSGotoCats();
						} catch (err) {
							console.error(err);
						}
						resolve();
					}, m.wait * 1.5 - passed);
				}
			});
		};
		m.fsGotoCats.fsOn = m.fsGotoCatsOn;
		m.fsTimezoneOn = function () {
			return new Promise(async (resolve, reject) => {
				let now = Date.now();
				let passed = now - m.previous;
				if (passed > m.wait) {
					m.previous = now;
					try {
						await m.doFSTimezone();
					} catch (err) {
						console.error(err);
					}
					resolve();
				} else {
					m.$search_timezone.off("keyup.fs cut.fs paste.fs click.fs");
					setTimeout(async function () {
						m.$search_timezone.on("keyup.fs cut.fs paste.fs click.fs", m.fsTimezoneOn);
						m.previous = Date.now();
						try {
							await m.doFSTimezone();
						} catch (err) {
							console.error(err);
						}
						resolve();
					}, m.wait * 1.5 - passed);
				}
			});
		};
		m.fsTimezone.fsOn = m.fsTimezoneOn;
		m.$input_cats.on("keydown.fs", function (e: Event) {
			m.onKeydownInFS(e, m.fsCat);
		});
		m.$multireco_input_cats.on("keydown.fs", function (e: Event) {
			m.onKeydownInFS(e, m.fsMRCat);
		});
		m.$goto_cats.on("keydown.fs", function (e: Event) {
			m.onKeydownInFS(e, m.fsGotoCats);
		});
		m.$search_timezone.on("keydown.fs", function (e: Event) {
			m.onKeydownInFS(e, m.fsTimezone);
		});
		let l = m.myCatList.length;
		for (let i = l - 1; i >= 0; i--) {
			let cat = m.myCatList[i].cat;
			if (!m.fsCat.fullList[cat]) {
				m.fsCat.fullList[cat] = { i: m.fsCat.fullList.length, txt: m.splitHangul(cat), cat, html: m.escapeOnlyTag(cat) };
				m.fsCat.fullList.push(m.fsCat.fullList[cat]);
			}
			if (!m.fsMRCat.fullList[cat]) {
				m.fsMRCat.fullList[cat] = { i: m.fsMRCat.fullList.length, txt: m.splitHangul(cat), cat, html: m.escapeOnlyTag(cat) };
				m.fsMRCat.fullList.push(m.fsMRCat.fullList[cat]);
			}
		}
		l = m.catList.length;
		for (let i = l - 1; i > 0; i--) {
			let cat = m.catList[i].cat;
			m.fsGotoCats.fullList[l - 1 - i] = m.fsGotoCats.fullList[cat] = { i: l - 1 - i, txt: m.splitHangul(cat), cat, html: m.escapeOnlyTag(cat) };
			m.catUriList[cat] = { cat, down: false };
		}
		m.fsGotoCats.fullList[l - 1] = m.fsGotoCats.fullList[""] = { i: l - 1, txt: m.splitHangul("Uncategorized"), cat: "", html: m.escapeOnlyTag("Uncategorized") };
		m.$input_cats.trigger("keyup.fs");
		m.$multireco_input_cats.trigger("keyup.fs");
		m.$goto_cats.trigger("keyup.fs");

		//////////////////////////////////////
		// Put/Delete/Change Cats
		//////////////////////////////////////
		m.putCat = function (cat) {
			return new Promise(async (resolve, reject) => {
				let res = false;
				cat = m.formatCats(cat);
				if (!cat) {
					reject(res);
				}
				let pre = "\n";
				let fullCats = "\n" + m.unescapeHTML(m.myCatListHTMLEscaped.trim()) + "\n";
				let levels = cat.split("--");
				let start = 0;
				let end = fullCats.length;
				for (let j = 0; j < levels.length; j++) {
					let subStr = fullCats.substring(start, end);
					let toFind = pre + levels[j] + "\n";
					let i = subStr.indexOf(toFind);
					if (i !== -1) {
						// * 찾아졌다면
						let ptnEnd = new RegExp(`\\n\\t{0,${pre.match(/\n(\t)*/)[0].length - 1}}[^\\t\\n]`, "g");
						ptnEnd.lastIndex = i + toFind.length - 1;
						// * subStr 중에 다음 ptnEnd 를 찾기 시작할 lastIndex 설정. Last "\n" 빼고 그 전부터 "\n" 로 시작하는 부분부터 search 시작.
						let matchEnd = ptnEnd.exec(subStr);
						if (matchEnd !== null) {
							// ! end 찾는 일이 제일 중요함.
							end = start + matchEnd.index + 1;
							// ! with "\n". 같은 level 의 가장 마지막 부분에 being put.
						} // ! match 가 안되었다면 원래의 끝 부분을 가리킴.
						start += i + toFind.length - 1;
						// * subStr 내에서 toFind 까지 포함한 start index without last "\n".
						pre += "\t";
					} else {
						// * 찾아지지 않았다면 put cat hierarchy.
						let toPut = "";
						for (; j < levels.length; j++) {
							toPut += pre + levels[j];
							pre += "\t";
						}
						if (toPut.length) {
							fullCats = fullCats.substring(0, end - 1) + toPut + fullCats.substring(end - 1);
							res = true;
						}
					}
				}
				console.log("toPut result: ", res);
				if (res) {
					m.myCatListHTMLEscaped = m.escapeOnlyTag(fullCats.trim());
					setMyCatList(m.myCatListHTMLEscaped);
					if (m.myPage) {
						m.catListHTMLEscaped = m.myCatListHTMLEscaped;
						setUserCatList(m.catListHTMLEscaped);
						console.log("m.catListHTMLEscaped", m.catListHTMLEscaped);
					}
				}
				resolve(res);
			});
		};
		m.deleteCat = function (cat) {
			return new Promise(async (resolve, reject) => {
				let res = false;
				if (cat === null || cat.length === 0) {
					return resolve(res);
				}
				cat = m.unescapeHTML(m.formatCats(cat));
				let levels = cat.split("--");
				let pre = "\n";
				let start0 = 0;
				let start = 0;
				let fullCats = "\n" + m.unescapeHTML(m.myCatListHTMLEscaped.trim()) + "\n";
				let end = fullCats.length;
				let subStr;
				for (let j = 0; j < levels.length; j++) {
					subStr = fullCats.substring(start, end);
					let toFind = pre + levels[j] + "\n";
					let i = subStr.indexOf(toFind);
					console.log("deleteCat cat toFind: ", toFind, "\nsubStr: ", subStr);
					if (i === -1) {
						console.log("deleteCat cat: ", cat, " not found");
						return resolve(res);
					} else {
						let ptnEnd = new RegExp(pre.replace(/\n/g, "\\n").replace(/\t/g, "\\t") + "[^\\t\\n]", "g");
						console.log("ptnEnd: ", ptnEnd);
						ptnEnd.lastIndex = i + toFind.length - 1;
						let matchEnd = ptnEnd.exec(subStr); // 다음 same level indent "\n\t...baseCat\n" 을 찾음.
						if (matchEnd !== null) {
							end = start + matchEnd.index + 1;
						}
						start0 = start + i;
						start += i + toFind.length - 1;
						pre += "\t";
					}
				}
				subStr = fullCats.substring(start + 1, end);
				// * subStr=subCats+"\n"
				// * if no subCats, this is empty.
				if (subStr.length) {
					fullCats = fullCats.substring(0, start0 + 1) + fullCats.substring(end);
					// delete a cat if there is no subCat.
					res = true;
				}
				console.log("deleteCat result: ", res);
				if (res) {
					m.myCatListHTMLEscaped = m.escapeOnlyTag(fullCats.trim());
					setMyCatList(m.myCatListHTMLEscaped);
					if (m.myPage) {
						m.catListHTMLEscaped = m.myCatListHTMLEscaped;
						setUserCatList(m.catListHTMLEscaped);
						console.log("m.catListHTMLEscaped", m.catListHTMLEscaped);
					}
				}
				resolve(res);
			});
		};
		m.$recoDeleted = [];
		m.refreshFSToRs = function (cat) {
			return new Promise(async function (resolve, reject) {
				cat = cat ?? m.currentCat;
				let fs0 = m.fsGo;
				let fs = m.fsToRs;
				let fsFL = (fs.fullList = []);
				let uris = m.catUriList[cat]?.uris;
				if (!uris) {
					await m.getUriList("cat\n" + (cat === "" ? "\tp" : cat));
					uris = m.catUriList[cat].uris;
				}
				for (let i = 0; i < uris.length; i++) {
					let uri = uris[i];
					let r = m.userRecos[uri];
					let catsSplit = m.catsToString(r?.cats).split(";");
					fsFL[uri] = { i: fsFL.length, catsSplit, uri, r, txt: m.splitHangul(r?.title), html: m.escapeOnlyTag(r?.title) };
					fsFL.push(fsFL[uri]);
					if (!fs0.fullList[uri]) {
						fs0.fullList[uri] = { uri, r, i: fs0.fullList.length, txt: m.splitHangul(`${r?.cats} :: ${r?.title}`), html: m.escapeOnlyTag(r?.title), catAndI: {} };
					}
					if (!fs0.fullList[uri].catAndI) {
						fs0.fullList[uri].catAndI = {};
					}
					fs0.fullList[uri].catAndI[cat] = { cat, i };
				}
				for (let i = 0; i < m.$recoDeleted.length; i++) {
					let r = m.$recoDeleted[i].r;
					let uri = r.uri;
					let catsSplit = m.catsToString(m.$recoDeleted[i].r?.cats).split(";");
					fs0.fullList[uri] = { i: `deleted-${i}`, catsSplit, uri, r, txt: m.splitHangul(`${r?.cats} :: ${r?.title}`), html: m.escapeOnlyTag(r?.title), catAndI: {} };
					for (let j = 0; j < catsSplit.length; j++) {
						let catJ = catsSplit[j];
						fs0.fullList[uri].catAndI[catJ] = { cat: catJ, i: `deleted-${i}` };
					}
				}
				await m.fsToRsInRangeCheck();
				resolve();
			});
		};
		// * uri is a string without "\n" or string array in which element is a string without "\n".
		m.putCats_UriToLists = function (cats, uri) {
			return new Promise(async function (resolve, reject) {
				// uri
				// A	uri[0]=A
				// B	uri[1]=B
				// C	uri[2]=C
				// No reverse() is needed.
				let catsSplit = m.formatCats(cats).split(";");
				let catIsPut = false;
				for (let i = 0; i < catsSplit.length; i++) {
					let cat = catsSplit[i];
					if (m.myCatUriList[cat]?.has) {
						if (uri?.constructor === String) {
							uri = await m.formatURIFully(uri);
							m.myCatUriList[cat].UriList = m.myCatUriList[cat].UriList.trim() + "\n" + uri;
							m.myCatUriList[cat].uris[uri] = { uri, i: m.myCatUriList[cat].uris.length };
							m.myCatUriList[cat].uris.push(uri);
						} else if (uri?.constructor === Array) {
							for (let i = m.myCatUriList[cat].uris.length, k = 0, l = 0; k < (uri as string[]).length; k++) {
								let uriK = await m.formatURIFully((uri as string[])[k]);
								m.myCatUriList[cat].UriList = "\n" + m.myCatUriList[cat].UriList.trim() + "\n";
								let indexOfUriK = m.myCatUriList[cat].UriList.indexOf("\n" + uriK + "\n");
								if (indexOfUriK === -1) {
									m.myCatUriList[cat].UriList += uriK + "\n";
									// * Newest to the bottom.
									m.myCatUriList[cat].uris[uriK] = { uri: uriK, i: i + l };
									l++;
									m.myCatUriList[cat].uris.push(uriK);
								}
							}
						}
					} else if (!m.myCatUriList[cat]) {
						await m.getMyUriList("cat\n" + (cat === "" ? "\tp" : cat));
						catIsPut = (await m.putCat(cat)) || catIsPut;
						if (!m.myCatUriList[cat]) {
							if (uri?.constructor === String) {
								uri = await m.formatURIFully(uri);
								m.myCatUriList[cat] = { cat, down: true, has: true, UriList: `\n${uri}\n`, uris: [uri] };
							} else if (uri?.constructor === Array) {
								m.myCatUriList[cat] = { cat, down: true, has: true, UriList: `\n${(uri as string[]).map((v) => m.encloseStr(v)).join("\n")}\n`, uris: [] };
								for (let j = 0; j < (uri as string[]).length; j++) {
									let uriJ = (uri as string[])[j];
									m.myCatUriList[cat].uris[uriJ] = { uri: uriJ, i: m.myCatUriList[cat].uris.length };
									m.myCatUriList[cat].uris.push(uriJ);
								}
							}
						}
					}
				}
				resolve(catIsPut);
			});
		};
		m.indexOfUriOnCatUriListCat = function (catUriListCat, uri) {
			let fullURIs = "\n" + catUriListCat.UriList.trim() + "\n";
			return { k: fullURIs.indexOf("\n" + uri + "\n"), fullURIs };
		};
		m.delCats_UriFromLists = function (cats, uri) {
			return new Promise(async function (resolve, reject) {
				let superCatIsDeleted = false;
				let catsSplit = cats.split(";");
				for (let i = 0; i < catsSplit.length; i++) {
					let cat = catsSplit[i];
					if (!m.myCatUriList[cat]?.has) {
						await m.getMyUriList("cat\n" + (cat === "" ? "\tp" : cat));
					}
					let { k, fullURIs } = m.indexOfUriOnCatUriListCat(m.myCatUriList[cat], uri);
					if (k !== -1) {
						m.myCatUriList[cat].UriList = (fullURIs.substring(0, k) + fullURIs.substring(k + uri.length + 1)).trim();
						if (m.myCatUriList[cat].uris[uri]) {
							m.myCatUriList[cat].uris.splice(m.myCatUriList[cat].uris[uri].i, 1);
							for (let j = 0; j < m.myCatUriList[cat].uris.length; j++) {
								m.myCatUriList[cat].uris[m.myCatUriList[cat].uris[j]].i = j;
							}
							m.myCatUriList[cat].uris[uri].i = `deleted-${m.deletedRecosCount}`;
						}
					}
					if (m.myCatUriList[cat]?.UriList?.trim().length === 0) {
						let catIsDeleted = true;
						while (cat !== null && catIsDeleted) {
							catIsDeleted = false;
							if (!m.myCatUriList[cat]?.has) {
								await m.getMyUriList("cat\n" + (cat === "" ? "\tp" : cat));
							}
							if (m.myCatUriList[cat]?.UriList?.trim().length === 0) {
								catIsDeleted = await m.deleteCat(cat);
								superCatIsDeleted = superCatIsDeleted || catIsDeleted;
							}
							cat = m.getSuperCat(cat);
						}
					}
				}
				resolve(superCatIsDeleted);
			});
		};
		// * uri is a single string or string array.
		m.changeCats_UriList = function (oldCats, newCats, uri) {
			oldCats = m.catsToString(oldCats);
			newCats = m.catsToString(newCats);
			return new Promise(async function (resolve, reject) {
				let catIsDeletedOrPut = false;
				if (uri && uri.constructor === String) {
					let oldCatSplit = m.formatCats(oldCats).split(";");
					let newCatSplit = m.formatCats(newCats).split(";");
					let o = [];
					let n = [];
					for (let i = 0; i < oldCatSplit.length; i++) {
						o[oldCatSplit[i]] = true;
					}
					newCats = "";
					for (let i = 0; i < newCatSplit.length; i++) {
						if (o[newCatSplit[i]]) {
							o[newCatSplit[i]] = false;
							n[newCatSplit[i]] = false;
						} else {
							newCats += newCatSplit[i] + ";";
							n[newCatSplit[i]] = true;
						}
					}
					oldCats = "";
					for (let p in o) {
						if (o[p]) {
							oldCats += p + ";";
						}
					}
					if (oldCats.length > 0) {
						catIsDeletedOrPut = catIsDeletedOrPut || (await m.delCats_UriFromLists(oldCats.substring(0, oldCats.length - 1), uri));
					}
					if (newCats.length > 0) {
						catIsDeletedOrPut = catIsDeletedOrPut || (await m.putCats_UriToLists(newCats.substring(0, newCats.length - 1), uri));
					}
				} else if (uri && uri.constructor === Array) {
					let newCatSplit = m.formatCats(newCats).split(";");
					for (let j = 0; j < (uri as string[]).length; j++) {
						let uriJ = (uri as string[])[j];
						let oldCatSplit = m.formatCats(m.myRecos[uriJ].cats).split(";");
						let o = [];
						let n = [];
						for (let i = 0; i < oldCatSplit.length; i++) {
							o[oldCatSplit[i]] = true;
						}
						newCats = "";
						for (let i = 0; i < newCatSplit.length; i++) {
							if (o[newCatSplit[i]]) {
								o[newCatSplit[i]] = false;
								n[newCatSplit[i]] = false;
							} else {
								newCats += newCatSplit[i] + ";";
								n[newCatSplit[i]] = true;
							}
						}
						oldCats = "";
						for (let p in o) {
							if (o[p]) {
								oldCats += p + ";";
							}
						}
						if (oldCats.length > 0) {
							catIsDeletedOrPut = catIsDeletedOrPut || (await m.delCats_UriFromLists(oldCats.substring(0, oldCats.length - 1), uriJ));
						}
						if (newCats.length > 0) {
							catIsDeletedOrPut = catIsDeletedOrPut || (await m.putCats_UriToLists(newCats.substring(0, newCats.length - 1), uriJ));
						}
					}
				}
				if (catIsDeletedOrPut) {
					if (m.myPage) {
						await m.catListToHTML();
					}
					// await m.updateMRCatFS();
					await m.updateCatFS();
					await m.updateGotoCatsFS();
				}
				resolve(catIsDeletedOrPut);
			});
		};

		////////////////////////////////////////////////////
		// Point range
		////////////////////////////////////////////////////
		m.$show_recos_without_points.on("click", function (e) {
			if (m.$show_recos_without_points.hasClass("enabled")) {
				m.$show_recos_without_points.removeClass("enabled");
				m.showRWOP = false;
			} else {
				m.$show_recos_without_points.addClass("enabled");
				m.showRWOP = true;
			}
			clearTimeout(m.timeOutRange);
			m.timeOutRange = setTimeout(async function () {
				await m.getUriListAndShowRecosOnCat(m.currentCat, true);
			}, m.wait);
		});
		m.PRtoFixed = function (w) {
			// 0.0 ~ 10.0
			return ((1.0 * m.PRmax * w) / m.PRw).toFixed(1);
		};
		m.PRtoFixed1 = function (w1) {
			// 0.0 ~ 10.0
			return ((1.0 * m.PRmax * w1) / m.PRw1).toFixed(1);
		};
		m.$window.on("resize.PR", function () {
			m.PRw = m.$point_range.width();
			m.PRw1 = m.$point_range1.width();
		});
		m.$window.trigger("resize.PR");
		m.mmInPR = function (e) {
			window.getSelection().removeAllRanges();
			e.preventDefault();
			e.stopPropagation();
			let x = e.type === "touchmove" ? (e as TouchEvent).touches[0].clientX : (e as MouseEvent).clientX;
			let w = x - m.$point_range.offset().left + m.$window.scrollLeft();
			w = w < 0 ? 0 : w;
			w = w > m.PRw ? m.PRw : w;
			let w1 = ((1.0 * w) / m.PRw) * m.PRw1;
			w1 = w1 < 0 ? 0 : w1;
			w1 = w1 > m.PRw1 ? m.PRw1 : w1;
			let changed = false;
			if (m.mdInPRL) {
				if (w > m.PRRw) {
					w = m.PRRw;
				}
				if (m.PRLw !== w) {
					m.PRLw = w;
					m.$point_range_left.css({ left: `calc(${(m.PRLw / m.PRw) * 100}% - 23px)` });
					m.$point_range_bar.css({ left: `${(m.PRLw / m.PRw) * 100}%` });
					changed = true;
				}
				if (w1 > m.PRRw1) {
					w1 = m.PRRw1;
				}
				if (m.PRLw1 !== w1) {
					m.PRLw1 = w1;
					m.$point_range_left1.css({ left: `calc(${(m.PRLw1 / m.PRw1) * 100}% - 15px)` });
					m.$point_range_bar1.css({ left: `${(m.PRLw1 / m.PRw1) * 100}%` });
					changed = true;
				}
			}
			if (m.mdInPRR) {
				if (w < m.PRLw) {
					w = m.PRLw;
				}
				if (m.PRRw !== w) {
					m.PRRw = w;
					m.$point_range_right.css({ right: `calc(${100 - (m.PRRw / m.PRw) * 100}% - 23px)` });
					m.$point_range_bar.css({ right: `${100 - (m.PRRw / m.PRw) * 100}%` });
					changed = true;
				}
				if (w1 < m.PRLw1) {
					w1 = m.PRLw1;
				}
				if (m.PRRw1 !== w1) {
					m.PRRw1 = w1;
					m.$point_range_right1.css({ right: `calc(${100 - (m.PRRw1 / m.PRw1) * 100}% - 15px)` });
					m.$point_range_bar1.css({ right: `${100 - (m.PRRw1 / m.PRw1) * 100}%` });
					changed = true;
				}
			}
			if (changed) {
				clearTimeout(m.timeOutRange0);
				let PRL = Number(m.PRtoFixed(m.PRLw));
				let PRR = Number(m.PRtoFixed(m.PRRw));
				if (m.mdInPRL) {
					PRL = PRL / m.PRmax;
					if (m.ptsRangeFrom !== PRL) {
						m.ptsRangeFrom = Number(PRL.toFixed(2));
						m.docCookies.setItem("PRL", PRL.toFixed(2), Infinity, "/", false, true);
						m.args.PRL = PRL.toFixed(2);
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					}
				}
				if (m.mdInPRR) {
					PRR = PRR / m.PRmax;
					if (m.ptsRangeTo !== PRR) {
						m.ptsRangeTo = Number(PRR.toFixed(2));
						m.docCookies.setItem("PRR", PRR.toFixed(2), Infinity, "/", false, true);
						m.args.PRR = PRR.toFixed(2);
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					}
				}
				m.$point_range_result.html((m.ptsRangeFrom * m.PRmax).toFixed(1) + "~" + (m.ptsRangeTo * m.PRmax).toFixed(1) + " / " + m.PRmax);
				m.timeOutRange0 = setTimeout(async function () {
					await m.getUriListAndShowRecosOnCat(m.currentCat, false);
					let fs = m.fsToRs;
					fs[0].ptnSH = m.splitHangul("$!@#");
					fs.$fs.trigger("keyup.fs");
					if (!fs.$fsl.find(".list-item.selected").length) {
						fs.$fsl.find(".list-item").eq(0).trigger("click");
					}
				}, m.wait);
			}
		};
		m.mmInPR1 = function (e) {
			window.getSelection().removeAllRanges();
			e.preventDefault();
			e.stopPropagation();
			m.PRw = m.$point_range.width();
			m.PRw1 = m.$point_range1.width();
			let x = e.type === "touchmove" ? (e as TouchEvent).touches[0].clientX : (e as MouseEvent).clientX;
			let w1 = x - m.$point_range1.offset().left + m.$window.scrollLeft();
			w1 = w1 < 0 ? 0 : w1;
			w1 = w1 > m.PRw1 ? m.PRw1 : w1;
			let w = ((1.0 * w1) / m.PRw1) * m.PRw;
			w = w < 0 ? 0 : w;
			w = w > m.PRw ? m.PRw : w;
			let changed = false;
			if (m.mdInPRL1) {
				if (w > m.PRRw) {
					w = m.PRRw;
				}
				if (m.PRLw !== w) {
					m.PRLw = w;
					m.$point_range_left.css({ left: `calc(${(m.PRLw / m.PRw) * 100}% - 23px)` });
					m.$point_range_bar.css({ left: `${(m.PRLw / m.PRw) * 100}%` });
					changed = true;
				}
				if (w1 > m.PRRw1) {
					w1 = m.PRRw1;
				}
				if (m.PRLw1 !== w1) {
					m.PRLw1 = w1;
					m.$point_range_left1.css({ left: `calc(${(m.PRLw1 / m.PRw1) * 100}% - 15px)` });
					m.$point_range_bar1.css({ left: `${(m.PRLw1 / m.PRw1) * 100}%` });
					changed = true;
				}
			}
			if (m.mdInPRR1) {
				if (w < m.PRLw) {
					w = m.PRLw;
				}
				if (m.PRRw !== w) {
					m.PRRw = w;
					m.$point_range_right.css({ right: `calc(${100 - (m.PRRw / m.PRw) * 100}% - 23px)` });
					m.$point_range_bar.css({ right: `${100 - (m.PRRw / m.PRw) * 100}%` });
					changed = true;
				}
				if (w1 < m.PRLw1) {
					w1 = m.PRLw1;
				}
				if (m.PRRw1 !== w1) {
					m.PRRw1 = w1;
					m.$point_range_right1.css({ right: `calc(${100 - (m.PRRw1 / m.PRw1) * 100}% - 15px)` });
					m.$point_range_bar1.css({ right: `${100 - (m.PRRw1 / m.PRw1) * 100}%` });
					changed = true;
				}
			}
			if (changed) {
				clearTimeout(m.timeOutRange1);
				let PRL = Number(m.PRtoFixed1(m.PRLw1));
				let PRR = Number(m.PRtoFixed1(m.PRRw1));
				if (m.mdInPRL1) {
					PRL = PRL / m.PRmax;
					if (m.ptsRangeFrom !== PRL) {
						m.ptsRangeFrom = Number(PRL.toFixed(2));
						m.docCookies.setItem("PRL", PRL.toFixed(2), Infinity, "/", false, true);
						m.args.PRL = PRL.toFixed(2);
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					}
				}
				if (m.mdInPRR1) {
					PRR = PRR / m.PRmax;
					if (m.ptsRangeTo !== PRR) {
						m.ptsRangeTo = Number(PRR.toFixed(2));
						m.docCookies.setItem("PRR", PRR.toFixed(2), Infinity, "/", false, true);
						m.args.PRR = PRR.toFixed(2);
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					}
				}
				m.$point_range_result.html((m.ptsRangeFrom * m.PRmax).toFixed(1) + "~" + (m.ptsRangeTo * m.PRmax).toFixed(1) + " / " + m.PRmax);
				m.timeOutRange1 = setTimeout(async function () {
					await m.getUriListAndShowRecosOnCat(m.currentCat, false);
					let fs = m.fsToRs;
					fs[0].ptnSH = m.splitHangul("$!@#");
					fs.$fs.trigger("keyup.fs")
					if (!fs.$fsl.find(".list-item.selected").length) {
						fs.$fsl.find(".list-item").eq(0).trigger("click");
					}
				}, m.wait);
			}
		};

		m.$point_range_left.on("mousedown.mdPRL touchstart.mdPRL", function () {
			m.mdInPRL = true;
			m.$html.on("mousemove.mdInPRL touchmove.mdInPRL", function (e: Event) {
				m.mmInPR(e);
			});
			m.$html.on("mouseup.mdInPRL touchend.mdInPRL", function () {
				m.mdInPRL = false;
				m.$html.off("mouseup.mdInPRL touchend.mdInPRL mousemove.mdInPRL touchmove.mdInPRL");
			});
		});
		m.$point_range_right.on("mousedown.mdPRR touchstart.mdPRR", function () {
			m.mdInPRR = true;
			m.$html.on("mousemove.mdInPRR touchmove.mdInPRR", function (e: Event) {
				m.mmInPR(e);
			});
			m.$html.on("mouseup.mdInPRR touchend.mdInPRR", function () {
				m.mdInPRR = false;
				m.$html.off("mouseup.mdInPRR touchend.mdInPRR mousemove.mdInPRR touchmove.mdInPRR");
			});
		});

		m.$point_range_left1.on("mousedown.mdPRL1 touchstart.mdPRL1", function () {
			m.mdInPRL1 = true;
			m.$html.on("mousemove.mdInPRL1 touchmove.mdInPRL1", function (e: Event) {
				m.mmInPR1(e);
			});
			m.$html.on("mouseup.mdInPRL1 touchend.mdInPRL1", function () {
				m.mdInPRL1 = false;
				m.$html.off("mouseup.mdInPRL1 touchend.mdInPRL1 mousemove.mdInPRL1 touchmove.mdInPRL1");
			});
		});
		m.$point_range_right1.on("mousedown.mdPRR1 touchstart.mdPRR1", function () {
			m.mdInPRR1 = true;
			m.$html.on("mousemove.mdInPRR1 touchmove.mdInPRR1", function (e: Event) {
				m.mmInPR1(e);
			});
			m.$html.on("mouseup.mdInPRR1 touchend.mdInPRR1", function () {
				m.mdInPRR1 = false;
				m.$html.off("mouseup.mdInPRR1 touchend.mdInPRR1 mousemove.mdInPRR1 touchmove.mdInPRR1");
			});
		});

		m.$preview_desc.on("click", async function (e) {
			let descR = m.renderStrDescCmt(m.$input_desc.val());
			m.$input_desc.val(m.descCmtRToString(descR));
			m.$previewed_desc.html(String(await m.descCmtRToHTML(descR)));
		});
		m.$formatting_lyrics.on("click", function (e) {
			let descR = m.renderStrDescCmt(m.$input_desc.val());
			let lyrics = descR["#lyrics"] || descR["#lyrics:"] || descR["#가사"] || descR["#가사:"] || descR[""];
			if (lyrics) {
				let lyricsSplitted = lyrics.val?.trim().split("\n");
				for (let i = 0; i < lyricsSplitted.length; i++) {
					lyricsSplitted[i] = lyricsSplitted[i].replace(/\s+/g, " ").trim();
					// replacing all unicode whitespace.
					// https://stackoverflow.com/questions/61300904/removing-narrow-no-break-space-unicode-characters-u00a0-in-python-nlp
					// lyrics=lyrics.replace(/ /g, " ").replace(/ /, " ")...;
				}
				let trimedLyricsSplitted = lyricsSplitted.join("\n").split(/\n\n+/g);
				for (let i = 0; i < trimedLyricsSplitted.length; i++) {
					if (trimedLyricsSplitted[i].startsWith("You might also like")) {
						trimedLyricsSplitted.splice(i, 1);
						i--;
					}
				}
				lyrics.key = "#lyrics";
				lyrics.val = "\n\n" + trimedLyricsSplitted.join("\n\n") + "\n\n\n";
				descR["#lyrics"] = descR[lyrics.i] = lyrics;
			}
			m.$input_desc.val(m.descCmtRToString(descR));
		});

		m.fsToRsInRangeCheck = function () {
			return new Promise(async function (resolve, reject) {
				let fs = m.fsToRs;
				let l = fs.fullList.length;
				let nHiden = 0;
				let nShown = 0;
				let nDeleted = 0;
				for (let k = l - 1; k >= 0; k--) {
					let fsFLk = fs.fullList[k];
					if (String(fsFLk.i).startsWith("from-recoms-")) {
						fsFLk.inRange = true;
						continue;
					}
					let uri = fsFLk.uri;
					let r = fsFLk.r;
					let val = r?.val?.val;
					fsFLk.txt = m.splitHangul(r?.title);
					fsFLk.html = m.escapeOnlyTag(r?.title);
					if (fsFLk.deleted) {
						nDeleted++;
					} else {
						if (val === undefined || val === -1) {
							if (m.showRWOP) {
								fsFLk.inRange = true;
								nShown++;
							} else {
								fsFLk.inRange = false;
								nHiden++;
							}
						} else {
							if (m.ptsRangeFrom <= val && val <= m.ptsRangeTo) {
								fsFLk.inRange = true;
								nShown++;
							} else {
								fsFLk.inRange = false;
								nHiden++;
							}
						}
					}
				}
				let nUnrecoed = 0;
				if (!m.myPage) {
					for (let k = 0; k < l; k++) {
						let fsFLk = fs.fullList[k];
						let uri = fsFLk.uri;
						if (!fsFLk.deleted) {
							if (m.showOnlyUnrecoed && m.myRecos[uri].has) {
								if (fsFLk.inRange) {
									nShown--;
									nHiden++;
								}
								fsFLk.inRange = false;
							}
							if (!m.myRecos[uri].has) {
								nUnrecoed++;
							}
						}
					}
				}
				await m.reTriggerFS(fs);
				let nOfRecos = `${m.userId} has ${l} recos (${nShown} to be shown, ${nHiden} hiden, and ${nDeleted} deleted.) on cat=${m.escapeOnlyTag(m.currentCat)}.`;
				if (!m.myPage) {
					nOfRecos += `<br/>You have ${nUnrecoed} unrecoed recos of ${m.userId}'s cat=${m.escapeOnlyTag(m.currentCat)}.`;
				}
				m.$numbers_of_recos.html(nOfRecos);
				resolve();
			});
		};
		m.showRecosOnCat = function (elem, from) {
			return new Promise(async function (resolve, reject) {
				console.log("showRecosOnCat\nelem", elem, "\nfrom", from);
				if (elem === undefined || elem === null) {
					await m.refreshFSToRs(m.currentCat);
					await m.doFSToRs("default");
					if (m.lastRecoMode === "" && m.recoMode === "multireco") {
						m.$contents.addClass("multireco");
						m.$window.trigger({ type: "keydown", code: "KeyX" } as any);
						m.lastRecoMode = "multireco";
					} else if (m.lastRecoMode === "daily-mix" && m.recoMode === "multireco") {
						m.$contents.addClass("multireco");
						m.$window.trigger({ type: "keydown", code: "KeyX" } as any);
						m.lastRecoMode = "multireco";
					} else if (m.lastRecoMode === "multireco" && m.recoMode === "") {
						m.$contents.removeClass("multireco");
						m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
						m.lastRecoMode = "";
					} else if (m.lastRecoMode === "daily-mix" && m.recoMode === "") {
						m.$contents.removeClass("multireco");
						m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
						m.lastRecoMode = "";
					}
				}
				let $elem = null;
				if (elem) {
					$elem = $(elem);
				}
				let fs = m.fsToRs;
				let l = fs.fullList.length;
				let strHTML = "";
				console.log("showRecosOnCat\nfs", m.fsToRs, "\nl", l);
				if (l <= 0) {
					m.$numbers_of_recos.html(`No reco in cat="${m.escapeOnlyTag(m.currentCat)}".`);
					m.$contents.html(strHTML);
					m.fsToRs.pauseVideo();
					m.$youtube.html("");
					m.$eveElse.html("");
					m.$reco_playing.html("");
					m.$eveElse_container.hide();
					m.$rC_youtube_container.hide();
				} else if (elem === undefined || elem === null) {
					from = l - 1;
					await m.fsToRsInRangeCheck();
					for (let i = from, k = 0; i >= 0; i -= m.maxShowReco, k++) {
						strHTML += `<div id="load-recos-${k}" class="button to-be-executed load-recos" onclick="m.showRecosOnCat(this,${i})">Load more... <span class="from">${i}</span> to <span class="to">${i - m.maxShowReco + 1 >= 0 ? i - m.maxShowReco + 1 : 0}</span></div>`;
					}
					m.$contents.html(strHTML);
					// TODO: remove this.
					// m.$contents.find(".to-be-executed").eq(0).trigger("click");
				} else if (from !== undefined && from !== null && from.constructor === Number) {
					for (let i = from, k = 0; i >= 0 && k < m.maxShowReco; i--, k++) {
						let fsFLi = fs.fullList[i];
						if (fs.shuffled[i]) {
							fsFLi = fs.fullList[fs.shuffled[i].i];
						}
						let r = fsFLi?.r;
						if (r) {
							try {
								let recoHTML = await m.recoHTML(r, false, fsFLi.inRange);
								strHTML += recoHTML;
							} catch (err) {
								console.error(err);
							}
						}
					}
					let beforeLoadSH = document.documentElement.scrollHeight;
					let beforeST = m.$window.scrollTop();
					if ($elem.offset().top - beforeST <= window.innerHeight / 3.0) {
						// Scroll from downside to upside.
						$elem.replaceWith(strHTML);
						let afterLoadSH = document.documentElement.scrollHeight;
						setTimeout(function () {
							m.$window.scrollTop(afterLoadSH - beforeLoadSH + beforeST);
						}, 128);
					} else {
						// Scroll from upside to downside.
						$elem.replaceWith(strHTML);
					}
				}
				await m.reNewAndReOn();
				resolve();
			});
		};
		m.editOrRecoToMine = async function (elem, fillDefs) {
			if (!m.$new_reco.is(":visible")) {
				m.$new_reco.show();
				let $reco = $(elem).closest(".reco");
				let uri = m.unescapeHTML($reco.find(".textURI").html());
				let r = m.myRecos[uri];
				if (!r) {
					r = m.myRecos[uri] = { uri };
				}
				if (!(r && r.has)) {
					r = m.userRecos[uri];
				}
				m.$input_uri.off("input.change keyup.change keydown.change cut.change paste.change click.change focus.change");
				m.$input_uri.val(r?.uri ?? "");
				m.$input_uri[0].disabled = true;
				if (uri.length !== 0 && uri !== m.lastURI) {
					if (m.myPage) {
						await m.formatURIAndGetAndShowDefsAndRecoInNewReco(true, fillDefs, true);
						// * (noFormatURI, fillDefs, keepOriginal = false)
					} else {
						await m.formatURIAndGetAndShowDefsAndRecoInNewReco(false, fillDefs);
						// * (noFormatURI, fillDefs, keepOriginal = false)
					}
				}
				m.wST = m.$window.scrollTop();
				m.$window.off("scroll.stop");
				m.$window.on("scroll.stop", function (e) {
					e.preventDefault();
					e.stopPropagation();
					m.$window.scrollTop(m.wST);
				});
			} else {
				m.$window.off("scroll.stop");
			}
		};
		m.getRecos = function (uris, recos, cat) {
			cat = cat ?? m.currentCat;
			let getRecosStr = "uri";
			let getRecosN = 0;
			let fs1 = m.fsToRs;
			for (let i = 0; i < uris.length; i++) {
				let uri = uris[i];
				let r = recos[uri];
				if (!r) {
					r = recos[uri] = { uri, down: false };
				}
				if (!r.down) {
					getRecosStr += "\n" + m.encloseStr(uri);
					getRecosN++;
				}
			}
			if (recos === m.userRecos) {
				fs1.fullList = [];
				for (let i = 0; i < uris.length; i++) {
					let uri = uris[i];
					fs1.fullList[i] = fs1.fullList[uri] = {
						i,
						uri,
						r: m.userRecos[uri],
					};
				}
			}
			return new Promise(function (resolve, reject) {
				if (getRecosN > 0) {
					let postURL = recos === m.userRecos ? `${m.userPath}/get-Recos` : m.myIndex ? `/user/${m.myId}/get-Recos` : null;
					if (postURL) {
						$.ajax({
							type: "POST",
							url: postURL,
							data: getRecosStr.replace(/%20/g, "%2520"),
							dataType: "text",
						})
							.fail(function () {
								m.$numbers_of_recos.html(`get-Recos of UriList on cat=${m.escapeOnlyTag(m.currentCat)} has failed.`);
								m.$contents.html("");
								reject();
							})
							.done(async function (resp) {
								resp = resp.trim();
								m.recoDowned(getRecosStr.substring(4), recos);
								await m.recoToEve(resp, recos, cat);
								resolve();
							});
					} else {
						resolve();
					}
				} else {
					resolve();
				}
			});
		};
		m.getAndShowRecosOnCat = function (cat) {
			return new Promise(async function (resolve, reject) {
				if (m.recoMode !== "neighbors" && m.recoMode !== "recoms") {
					if (!m.catUriList[cat]?.has) {
						await m.getUriList("cat\n" + (cat === "" ? "\tp" : cat));
					}
					let uris = m.catUriList[cat].uris;
					await m.getRecos(uris, m.userRecos, cat);
					if (!m.myIndex) {
						for (let i = 0; i < uris.length; i++) {
							let uri = String(uris[i]);
							if (!m.myRecos[uri]) {
								m.myRecos[uri] = { uri, down: true, has: false };
							}
						}
					} else if (!m.myPage) {
						await m.getRecos(uris, m.myRecos, cat);
					}
					if (m.lastCat !== cat) {
						m.recoedFromRecoms = 0;
					}
					// await m.refreshFSToRs(cat);
					await m.showRecosOnCat();
					let fs = m.fsToRs;
					if (m.lastCat !== cat || fs.lastIndex !== fs.currentIndex) {
						let k = fs.currentIndex;
						let $toRK = $(`#toR-${k}`);
						try {
							await fs.getAndPlayVideo($toRK[0]?.id === fs.$fsl.find(".list-item")[0]?.id);
							// * (cue, inListPlay = true)
						} catch (err) {
							console.error(err);
						}
					}
				}
				m.lastCat = m.currentCat = cat;
				resolve();
			});
		};
		m.getMyUriList = m.myPage ? m.getUriList : function (catListStr) {
			return new Promise(function (resolve, reject) {
				$.ajax({
					type: "POST",
					url: `${m.myPath}/get-UriList`,
					data: catListStr,
					dataType: "text",
				})
					.fail(function (resp) {
						m.$numbers_of_recos.html(`get-MyUriList of cat=${m.escapeOnlyTag(catListStr)} has failed.`);
						reject(`get-my-UriList of cat=${m.escapeOnlyTag(catListStr)} has failed.`);
					})
					.done(async function (resp) {
						// * resp=cat\tUriList\tcutP\terr
						let respJSON = await m.strToJSON(resp.replace(/%2520/g, "%20"));
						for (let i = 1; i < respJSON.length; i++) {
							let catULCat = (m.myCatUriList[respJSON[i]?.cat] = m.myCatUriList[respJSON[i]?.cat] ?? {});
							catULCat.down = true;
							catULCat.has = true;
							for (let prop in respJSON[i]) {
								if (isNaN(Number(prop))) {
									catULCat[prop] = respJSON[i][prop];
									// * {cat, UriList, cutP, err}
								}
							}
							catULCat.UriList = catULCat.UriList.trim();
							catULCat.uris = [];
							if (catULCat.UriList?.length !== 0) {
								catULCat.uris = (await m.strToJSON(catULCat.UriList, false, false)).map((v: string[]) => v[0]).reverse();
								// * Newest has the maximum index i.
								catULCat.UriList = catULCat.uris
									.map((v: string) => m.encloseStr(v))
									.join("\n")
									.trim();
								for (let k = 0; k < catULCat.uris.length; k++) {
									const uri = catULCat.uris[k];
									catULCat.uris[uri] = { i: k, uri };
									if (!m.myRecos[uri]) {
										m.myRecos[uri] = { uri, down: false };
									}
								}
							}
						}
						resolve(m.myRecos);
					});
			});
		};
		m.getUriList = function (catListStr) {
			return new Promise(function (resolve, reject) {
				$.ajax({
					type: "POST",
					url: `${m.userPath}/get-UriList`,
					data: catListStr,
					dataType: "text",
				})
					.fail(function () {
						m.$numbers_of_recos.html(`get-UriList of cat=${m.escapeOnlyTag(catListStr)} has failed.`);
						reject(`get-UriList of cat=${m.escapeOnlyTag(catListStr)} has failed.`);
					})
					.done(async function (resp) {
						// * resp=cat\tUriList\tcutP\terr
						let respJSON = await m.strToJSON(resp.replace(/%2520/g, "%20"));
						for (let i = 1; i < respJSON.length; i++) {
							let catULCat = (m.catUriList[respJSON[i]?.cat] = m.catUriList[respJSON[i]?.cat] ?? {});
							catULCat.down = true;
							catULCat.has = true;
							for (let prop in respJSON[i]) {
								if (isNaN(Number(prop))) {
									catULCat[prop] = respJSON[i][prop];
									// * {cat, UriList, cutP, err}
								}
							}
							catULCat.UriList = catULCat.UriList.trim();
							catULCat.uris = [];
							if (catULCat.UriList?.length !== 0) {
								catULCat.uris = (await m.strToJSON(catULCat.UriList, false, false)).map((v: string[]) => v[0]).reverse();
								// * Newest has the maximum index i.
								catULCat.UriList = catULCat.uris
									.map((v: string) => m.encloseStr(v))
									.join("\n")
									.trim();
								for (let k = 0; k < catULCat.uris.length; k++) {
									const uri = catULCat.uris[k];
									catULCat.uris[uri] = { i: k, uri };
									if (!m.userRecos[uri]) {
										m.userRecos[uri] = { uri, down: false };
									}
								}
							}
						}
						resolve(m.userRecos);
					});
			});
		};
		m.getMultiDefs = function (uris) {
			return new Promise(async function (resolve, reject) {
				if (uris) {
					$.ajax({
						type: "POST",
						url: "/reco/multidefs",
						data: uris.trim(),
						dataType: "text",
					}).done(async function (resp) {
						let defs = Object(await m.strToJSON(resp.trim()));
						for (let j = 1; j < defs.length; j++) {
							let uri = defs[j].uri;
							let recoDefs = m.recoDefs[uri];
							if (!recoDefs) {
								recoDefs = m.recoDefs[uri] = { uri };
							}
							recoDefs.down = true;
							recoDefs.defCats = Object(await m.strToJSON(String(defs[j]["def-cats"]), false));
							recoDefs.defTitles = Object(await m.strToJSON(String(defs[j]["def-titles"]), false));
							recoDefs.defDescs = Object(await m.strToJSON(String(defs[j]["def-descs"]), false));
						}
						resolve();
					});
				} else {
					reject();
				}
			});
		};
		m.loadMoreRecoms = async function (elem, from, until) {
			let cat = m.currentCat;
			let uris = "";
			until = until < 0 ? 0 : until;
			for (let i = from - 1; i >= until; i--) {
				let uri = m.recoms[cat][m.recomsSorted[cat][i]].uri;
				if (!m.recoDefs[uri]) {
					uris += uri + "\n";
				}
				if (!m.myRecos[uri]) {
					m.myRecos[uri] = { uri, down: true, has: false };
				}
			}
			try {
				await m.getMultiDefs(uris);
			} catch (err) {
				console.error(err);
			}
			let strHTML = "";
			for (let i = from - 1; i >= until; i--) {
				let uri = m.recoms[cat][m.recomsSorted[cat][i]].uri;
				let recomHTML = await m.recomHTML(m.userRecos[uri]);
				strHTML += String(recomHTML);
			}
			if (until > 0) {
				strHTML += `<div class="button cBoth" onclick="m.loadMoreRecoms(this, ${until}, ${until - 12})">More Recoms...</div>`;
			}
			$(elem).replaceWith(strHTML);
			await m.reNewAndReOn();
		};
		m.cutNeighbors = function (str) {
			$.ajax({
				type: "POST",
				url: `${m.userPath}/cut-Neighbors`,
				data: str,
				dataType: "text",
			}).done(function (resp) {
				if (resp === "cut") {
					m.$numbers_of_recos.html("Neighbors are cut.");
				} else {
					m.$numbers_of_recos.html("Neighbors are not cut. There must be a problem.");
				}
			});
		};
		m.withInTimeLimit = function (respJSONi) {
			let tLast = new Date(respJSONi.tLast.replace(/\s/, "T"));
			return (m.tNow.getTime() - tLast.getTime()) / 1000 <= m.TLinSec[`i${m.TLIndex}`];
		};
		m.showRecoms = function (respJSON, cat, plusRandom = true) {
			return new Promise(async function (resolve, reject) {
				let recomsCat: RecomsOnCat[] = m.recoms[cat];
				for (let i = respJSON.length - 1; i >= 0; i--) {
					let respJSONi = respJSON[i];
					let uri = respJSONi.uri;
					if (m.withInTimeLimit(respJSONi)) {
						let recomsCatURI: RecomsOnCat = recomsCat[uri];
						if (!recomsCatURI) {
							recomsCatURI = { uri: uri, simVals: [], valsStat: [], i: recomsCat.length, index: recomsCat.length };
							for (let k = 0; k <= m.valsStatN; k++) {
								recomsCatURI.valsStat[k] = 0;
							}
							recomsCatURI.valsStat["max"] = 0;
							recomsCat.push(recomsCatURI);
						}
						recomsCat[uri] = recomsCatURI;
						let simVal: SimVal = { user: respJSONi.user, user_id: respJSONi.user_id, val: respJSONi.val, cmt: respJSONi.cmt };
						if (!recomsCatURI.simVals[`user_${respJSONi.user}`]) {
							let catsSplit = respJSONi.cats.split(";");
							let simAvg100 = 0;
							let maxCat = null;
							for (let j = 0; j < catsSplit.length; j++) {
								let sim = m.neighbors[cat][`${simVal.user}\t${catsSplit[j]}`];
								if (sim?.simAvg100 > simAvg100) {
									simAvg100 = sim.simAvg100;
									// Get the largest sim of user cats.
									maxCat = catsSplit[j];
								}
							}
							simVal.simAvg100 = simAvg100;
							simVal.maxCat = maxCat;
							recomsCatURI.simVals[`user_${respJSONi.user}`] = simVal;
							recomsCatURI.simVals.push(simVal);
							recomsCatURI.valsStat[Math.round(simVal.val * m.valsStatN)] += simAvg100;
						}
					}
				}
				for (let i = 0; i < recomsCat.length; i++) {
					const recomsCatI: RecomsOnCat = recomsCat[i];
					for (let k = 0; k <= m.valsStatN; k++) {
						if (recomsCatI.valsStat[k] > recomsCatI.valsStat.max) {
							recomsCatI.valsStat.max = recomsCatI.valsStat[k];
						}
					}
				}
				m.recomsSorted[cat] = [];
				if (plusRandom) {
					m.recomsPlusRandomSorted[cat] = [];
				}
				for (let i = 0; i < recomsCat.length; i++) {
					m.recomsSorted[cat].push(i);
					if (plusRandom) {
						m.recomsPlusRandomSorted[cat].push(i);
					}
					let recomsCatI: RecomsOnCat = recomsCat[i];
					recomsCatI.simVals.cmtsSorted = [];
					for (let k = 0; k < recomsCatI.simVals.length; k++) {
						recomsCatI.simVals.cmtsSorted.push(k);
					}
					m.heapsort(recomsCatI.simVals, "simAvg100", recomsCatI.simVals.cmtsSorted, recomsCatI.simVals.length);
					let cmtsHTML = `<div class="cmts">`;
					for (let k = recomsCatI.simVals.length - 1; k >= 0; k--) {
						let j = recomsCatI.simVals.cmtsSorted[k];
						let simValJ: SimVal = recomsCatI.simVals[j];
						cmtsHTML += `<div class="cmt"><a target="_blank" href="${m.pathOfNeighbor(simValJ.user_id, simValJ.maxCat)}">Cat="${m.escapeOnlyTag(simValJ.maxCat)}" of ${m.escapeOnlyTag(simValJ.user)}</a> (${(simValJ.simAvg100 / 10000.0).toFixed(2)}) :: ${m.escapeOnlyTag(simValJ.cmt)}</div>`;
					}
					cmtsHTML += `</div>`;
					recomsCatI.cmtsHTML = cmtsHTML;
					let valSimSum = 0;
					let simSum = 0;
					for (let j = 0; j < recomsCatI.simVals.length; j++) {
						let simValJ = recomsCatI.simVals[j];
						valSimSum += simValJ.val * simValJ.simAvg100;
						simSum += simValJ.simAvg100;
					}
					let avgVal = 0;
					if (simSum !== 0) {
						simSum = simSum < m.minSimSum ? m.minSimSum : simSum;
						avgVal = (10.0 * valSimSum) / simSum;
					}
					let avgValPlusRandom = -10.0;
					if (plusRandom) {
						avgValPlusRandom = avgVal - 0.5 + Math.random();
					}
					let avgValStr = avgVal.toFixed(2);
					recomsCatI.avgVal = avgVal;
					recomsCatI.avgValStr = avgValStr;
					recomsCatI.avgValPlusRandom = avgValPlusRandom;
					recomsCatI.avgValPlusRandomStr = avgValPlusRandom.toFixed(2);
				}
				m.recomsSorted[cat].sortedUntil = m.heapsort(recomsCat, "avgVal", m.recomsSorted[cat], recomsCat.length);
				if (plusRandom) {
					m.recomsPlusRandomSorted[cat].sortedUntil = m.heapsort(recomsCat, "avgValPlusRandom", m.recomsPlusRandomSorted[cat], recomsCat.length);
				}
				let uris = "";
				for (let i = recomsCat.length - 1; i >= 0; i--) {
					let uri = recomsCat[m.recomsSorted[cat][i]].uri;
					if (!m.recoDefs[uri]) {
						uris += uri + "\n";
					}
					if (!m.myRecos[uri]) {
						m.myRecos[uri] = { uri, down: true, has: false };
					}
				}
				uris = uris.trim();
				if (uris !== "") {
					try {
						await m.getMultiDefs(uris);
					} catch (err) {
						console.error(err);
					}
				}
				let strHTML = `<div class="msg">You have ${recomsCat.length} recoms from your neighbors.</div>`;
				let recomsUntil = recomsCat.length - 12 < 0 ? 0 : recomsCat.length - 12;
				for (let i = recomsCat.length - 1; i >= recomsUntil; i--) {
					let uri = recomsCat[m.recomsSorted[cat][i]].uri;
					let recomHTML = "";
					if (m.myRecos[uri]?.has) {
						recomHTML = await m.recoHTML(m.myRecos[uri], false, true, true);
					} else {
						recomHTML = await m.recomHTML(m.myRecos[uri], false);
					}
					strHTML += recomHTML;
				}
				if (recomsUntil > 0) {
					strHTML += `<div class="button cBoth" onclick="m.loadMoreRecoms(this, ${recomsUntil}, ${recomsUntil - 12})">More Recoms...</div>`;
				}
				m.$contents_recoms.html(strHTML);
				await m.reNewAndReOn();
				resolve();
			});
		};
		m.doGetUriListAndShowRecosOnCat = async function (cat) {
			m.$numbers_of_recos.html(`Loading recos in cat="${m.escapeOnlyTag(cat)}".`);
			let catListCat = m.catList[cat];
			if (catListCat) {
				let catUriListCat = (m.catUriList[cat] = m.catUriList[cat] || {});
				if (!catUriListCat.down) {
					m.$numbers_of_recos.html(`Getting UriList on cat="${m.escapeOnlyTag(cat)}".`);
					await m.getUriList("cat\n" + (cat === "" ? "\tp" : cat));
				}
				await m.getAndShowRecosOnCat(cat);
			} else {
				m.$numbers_of_recos.html(`Cat="${m.escapeOnlyTag(cat)}" does not exist.`);
				m.$contents.html("");
			}
			return Promise.resolve();
		};
		m.getUriListAndShowRecosOnCat = function (cat, scroll) {
			return new Promise(async function (resolve, reject) {
				switch (m.recoMode) {
					case "multireco":
					case "":
					default: {
						await m.doGetUriListAndShowRecosOnCat(cat);
						m.lastRecoMode = m.recoMode;
						m.recosShown = true;
						return resolve();
						break;
					}
					case "daily-mix":
					case "recoms": {
						await m.doGetUriListAndShowRecosOnCat(cat);
						if (m.neighbors[cat]) {
							if (m.lastTLIndex === m.TLIndex && m.neighborsRecos[cat]?.length && m.recomsSorted[cat] && m.recomsPlusRandomSorted[cat]) {
								// TL for Time Limit.
								let strHTML = "";
								if (m.recoms[cat]?.length === 0) {
									strHTML = `<div class="msg">You have no recoms yet from your neighbors.</div>`;
								} else if (m.recoms[cat]?.length > 0) {
									strHTML = `<div class="msg">[--You have ${m.recoms[cat].length} recoms from your neighbors.--]</div>`;
									let fs = m.fsToRs;
									await m.reTriggerFS(fs);
									if (m.recoMode === "recoms") {
										let recomsUntil = m.recomsSorted[cat].length - 12 < 0 ? 0 : m.recomsSorted[cat].length - 12;
										for (let i = m.recoms[cat].length - 1; i >= recomsUntil; i--) {
											let uri = m.recoms[cat][m.recomsSorted[cat][i]].uri;
											let recomHTML = await m.recomHTML(m.userRecos[uri]);
											strHTML += recomHTML;
										}
										if (recomsUntil > 0) {
											strHTML += `<div class="button cBoth" onclick="m.loadMoreRecoms(this, ${recomsUntil}, ${recomsUntil - 12})">More Recoms...</div>`;
										}
									}
								}
								m.$contents_recoms.html(strHTML);
								if (m.recoMode === "daily-mix") {
									m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
									m.recosShown = true;
								} else {
									m.goDirectlyToHash("button-get-recoms");
									m.recosShown = false;
								}
								await m.reNewAndReOn();
								return resolve();
							} else {
								if (!m.neighborsRecos[cat] || !m.recomsSorted[cat]) {
									let req = `user\tcat`;
									let n = m.neighbors[cat].length;
									let until = n < m.neighborUpto ? 0 : n - m.neighborUpto;
									let sorted = m.neighbors[cat].sorted;
									for (let i = n - 1; i >= until; i--) {
										let neighborCatI = m.neighbors[cat][sorted[i]];
										req += `\n${neighborCatI.user_to}\t${neighborCatI.cat_to}`;
									}
									$.ajax({
										type: "POST",
										url: `${m.userPath}/get-Recoms`,
										data: req,
										dataType: "text",
									}).done(async function (resp) {
										let respJSON = await m.strToJSON(resp);
										for (let i = 1; i < respJSON.length; i++) {
											let val = m.val(respJSON[i].val);
											if (val.valid) {
												respJSON[i].val = val.val;
											} else {
												respJSON.splice(i, 1);
												i--;
											}
										}
										respJSON.splice(0, 1);
										m.neighborsRecos[cat] = respJSON;
										await m.showRecoms(m.neighborsRecos[cat], cat, true);
										if (m.recoMode === "daily-mix") {
											m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
											m.recosShown = true;
										} else {
											m.goDirectlyToHash("button-get-recoms");
											m.recosShown = false;
										}
										return resolve();
									});
								} else if (m.lastTLIndex !== m.TLIndex || !m.recomsPlusRandomSorted[cat]) {
									await m.showRecoms(m.neighborsRecos[cat], cat, true);
									m.lastTLIndex = m.TLIndex;
									if (m.recoMode === "daily-mix") {
										m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
										m.recosShown = true;
									} else {
										m.goDirectlyToHash("button-get-recoms");
										m.recosShown = false;
									}
									return resolve();
								}
							}
						} else {
							m.$numbers_of_recos.html(`Loading neighbors of cat="${m.escapeOnlyTag(cat)}".`);
							let cat_from = (m.currentCat = cat);
							$.ajax({
								type: "POST",
								url: `${m.userPath}/get-Neighbors`,
								data: cat_from,
								dataType: "text",
							})
								.fail(function (resp) {
									m.$numbers_of_recos.html(resp as unknown as string);
									reject();
								})
								.done(async function (resp) {
									let respJSON = await m.strToJSON(resp);
									let neighborsCat = m.neighbors[cat];
									let sorted = (neighborsCat.sorted = []);
									let n = 0;
									for (let i = 1; i < respJSON.length; i++) {
										let neighborI: Neighbor = respJSON[i];
										neighborI.cat_from = cat_from;
										let sumSim = (neighborI.sumSim = parseInt(String(neighborI.sumSim), 16));
										let nSim = (neighborI.nSim = parseInt(String(neighborI.nSim), 16));
										neighborI.simAvg100 = Math.round((100.0 * sumSim) / (nSim > 5 ? nSim : 5));
										if (!neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`]) {
											neighborsCat[n] = neighborI;
											neighborsCat[n].i = n;
											sorted[n] = n;
											neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`] = neighborsCat[n];
											n++;
										} else {
											let neighbor = neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`];
											if (neighbor.simAvg100 < neighborI.simAvg100) {
												neighbor.simAvg100 = neighborI.simAvg100;
												// Take the biggest simAvg100.
											}
										}
									}
									m.heapsort(neighborsCat, "simAvg100", sorted, sorted.length);
									m.$numbers_of_recos.html(`Loaded ${neighborsCat.length} neighbors of cat="${m.escapeOnlyTag(cat)}".`);
									m.neighbors[cat_from] = neighborsCat;
									await m.getUriListAndShowRecosOnCat(cat, scroll);
									// recursive calling.
									return resolve();
								});
						}
						break;
					}
					case "neighbors":
						m.$numbers_of_recos.html(`Loading neighbors of cat="${m.escapeOnlyTag(cat)}", and plotting charts.`);
						let cat_from = (m.currentCat = cat);
						$.ajax({
							type: "POST",
							url: `${m.userPath}/get-Neighbors`,
							data: cat_from,
							dataType: "text",
						})
							.fail(function (resp) {
								m.$contents.html(resp as unknown as string);
								if (scroll) {
									m.$window.scrollTop(m.$contents.offset().top);
								}
								m.recosShown = false;
								return resolve();
							})
							.done(async function (resp) {
								let respJSON = Object(await m.strToJSON(resp.trim()));
								let neighborsCat: NeighborsCat = [] as NeighborsCat;
								neighborsCat.sorted = [];
								let sorted = neighborsCat.sorted;
								let n = 0;
								if (respJSON.length > 1) {
									for (let i = 1; i < respJSON.length; i++) {
										let neighborI = respJSON[i];
										neighborI.cat_from = cat_from;
										let sumSim = (neighborI.sumSim = parseInt(neighborI.sumSim, 16));
										let nSim = (neighborI.nSim = parseInt(neighborI.nSim, 16));
										neighborI["simAvg100"] = Math.round((100.0 * sumSim) / (nSim > 5 ? nSim : 5));
										if (!neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`]) {
											neighborI.i = n;
											neighborsCat[n] = neighborI;
											sorted[n] = n;
											n++;
											neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`] = neighborI;
										} else if (neighborI.nSim > neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`].nSim) {
											neighborsCat[`${neighborI.user_to}\t${neighborI.cat_to}`] = neighborI;
										}
									}
									let until = (sorted.sortedUntil = m.heapsort(neighborsCat, "simAvg100", sorted, m.neighborUpto));
									let strHTML = ``;
									for (let i = neighborsCat.length - 1; i >= until; i--) {
										let neighborI = neighborsCat[sorted[i]];
										strHTML += `<div class="neighbor-con"><div class="neighbor-sim" style="width:${neighborI["simAvg100"] / 100.0}%"></div><div class="neighbor-a"><a target="_blank" href="${m.pathOfNeighbor(neighborI.user_id, neighborI.cat_to, "multireco")}">${m.escapeOnlyTag(neighborI.cat_to)} of ${m.escapeOnlyTag(neighborI.user_id)}'s Recoeve.net (${(neighborI["simAvg100"] / 100.0).toFixed(2)})</a> <span class="neighbor-tUpdate">${m.toLocalTime(neighborI.tUpdate)}</span></div></div>`;
									}
									strHTML = `<div class="msg">Loaded ${neighborsCat.length} neighbors of cat="${m.escapeOnlyTag(cat)}".</div>` + strHTML;
									m.$contents.html(strHTML);
									if (scroll) {
										m.$window.scrollTop(m.$contents.offset().top);
									}
									m.neighbors[cat_from] = neighborsCat;
									if (m.myPage && neighborsCat.length > 1000) {
										let str = `cat_from\t${cat_from}\n`;
										let str_user_to = `user_to`;
										let str_cat_to = `cat_to`;
										let cut_upto = neighborsCat.length - m.neighborUpto;
										for (let i = neighborsCat.length - 1; i >= cut_upto; i--) {
											let neighborI = neighborsCat[sorted[i]];
											str_user_to += `\t${neighborI.user_to}`;
											str_cat_to += `\t${neighborI.cat_to}`;
										}
										str += str_user_to + "\n" + str_cat_to;
										m.rmb_me(m.cutNeighbors, str);
									}
								} else {
									m.$contents.html(`<div class="msg">You have no neighbors on cat=${m.escapeOnlyTag(cat)}.</div>`);
								}
								m.recosShown = false;
								return resolve();
							});
						break;
				}
			});
		};
		m.refresh = function (cats, option, uriOrS) {
			return new Promise(async function (resolve, reject) {
				if (m.myPage) {
					cats = m.catsToString(cats);
					option = String(option);
					if (uriOrS.constructor !== Array) {
						uriOrS = [String(uriOrS)];
					}
					m.beInCurrentCat = false;
					let catsSplit = cats.split(";");
					let k = catsSplit.length - 1;
					if (m.currentCat !== undefined) {
						for (; k >= 0; k--) {
							if (catsSplit[k] === m.currentCat) {
								m.beInCurrentCat = true;
								break;
							}
						}
					}
					let cat0 = m.currentCat;
					if (!m.beInCurrentCat) {
						cat0 = catsSplit[0];
					}
					let cat = m.currentCat;
					if (!m.beInCurrentCat && !m.catUriList[cat0].uris) {
						await m.getUriList("cat\n" + (cat0 === "" ? "\tp" : cat0));
					}
					for (let uri of uriOrS) {
						let r = m.myRecos[uri];
						switch (option) {
							case "recoed": {
								if (m.myPage) {
									if (m.beInCurrentCat) {
										m.recoedFromRecoms++;
									}
									let fsGoFLUri = m.fsGo.fullList[uri];
									let r = m.myRecos[uri];
									// Must be there, because it is recoed.
									if (!fsGoFLUri) {
										fsGoFLUri = m.fsGo.fullList[m.fsGo.fullList.length] = m.fsGo.fullList[uri] = { uri, r, i: m.fsGo.fullList.length, catsSplit: m.catsToString(r?.cats).split(";"), txt: m.splitHangul(`${r?.cats} :: ${r?.title}`), html: m.escapeOnlyTag(r?.title), catAndI: {} };
									}
									if (!fsGoFLUri.catAndI) {
										fsGoFLUri.catAndI = {};
									}
									if (m.catUriList[cat0]?.has) {
										if (!m.catUriList[cat0].uris[uri]) {
											m.catUriList[cat0].uris[uri] = { uri, i: m.catUriList[cat0].uris.length };
											m.catUriList[cat0].uris.push(uri);
											m.catUriList[cat0].UriList = m.catUriList[cat0].UriList.trim() + "\n" + uri;
										}
									}
									if (!(m.catUriList[cat0]?.uris?.[uri]?.i || m.catUriList[cat0]?.uris?.[uri]?.i === 0)) {
										m.catUriList[cat0].uris[uri] = { uri, i: m.catUriList[cat0].uris[uri].length };
										m.catUriList[cat0].uris.push(uri);
									}
									fsGoFLUri.catAndI[cat0] = { cat: cat0, i: m.catUriList[cat0].uris[uri].i };

									m.$recoms_recos = m.$contents_recoms.find(".reco");
									for (let k = 0; k < m.$recoms_recos.length; k++) {
										let $reco = m.$recoms_recos.eq(k);
										let recoURI = m.unescapeHTML($reco.find(".textURI").html());
										if (recoURI === uri) {
											try {
												let recoHTML = await m.recoHTML(r, false, true, true, option);
												// * (r, inListPlay, inRange, inRecoms, additionalClass)
												$reco.replaceWith(recoHTML);
											} catch (err) {
												console.error(err);
											}
										}
									}
									try {
										let recoHTML = await m.recoHTML(r, true, true, false, option);
										// * (r, inListPlay, inRange, inRecoms, additionalClass)
										m.$reco_playing.html(recoHTML);
										let uriRendered = await m.uriRendering(uri, false, true, r[uri]?.descR);
										// * (uri, toA, inListPlay, descR)
										clearTimeout(m.setTimeoutCueOrLoadUri);
										m.recoURIPlaying = uri;
										m.cueOrLoadUri(true, uriRendered, true);
										// * (cue, uriRendered, inListPlay)
									} catch (err) {
										console.error(err);
									}
									try {
										let recoHTML = await m.recoHTML(r, false, true, false, option);
										// * (r, inListPlay, inRange, inRecoms, additionalClass)
										m.$contents.prepend(recoHTML);
									} catch (err) {
										console.error(err);
									}
								}
								break;
							}
							case "changed":
							case "deleted": {
								if (m.myPage && uri === m.unescapeHTML(m.$reco_playing.find(".reco>.textURI").html())) {
									if (option === "changed") {
										try {
											let r = m.myRecos[uri];
											let recoHTML = await m.recoHTML(r, true, true, false, option);
											// * (r, inListPlay, inRange, inRecoms, additionalClass)
											m.$reco_playing.html(String(recoHTML));
											m.fsToRs.getAndPlayVideo(true);
											// * (cue, inListPlay = true)
											await m.reNewAndReOn();
										} catch (err) {
											console.error(err);
										}
									} else if (option === "deleted") {
										m.fsToRs.pauseVideo();
										m.$reco_playing.html("");
										m.$eveElse.html("");
										m.$youtube.html("");
										m.$eveElse_container.hide();
										m.$rC_youtube_container.hide();
									}
								}
								if (m.myPage) {
									if (option === "changed") {
										m.$recoms_recos = m.$contents_recoms.find(".reco");
										for (let k = 0; k < m.$recoms_recos.length; k++) {
											let $reco = m.$recoms_recos.eq(k);
											let recoURI = m.unescapeHTML($reco.find(".textURI").html());
											if (recoURI === uri) {
												try {
													let recoHTML = await m.recoHTML(r, false, true, true, option);
													// * (r, inListPlay, inRange, inRecoms, additionalClass)
													$reco.replaceWith(String(recoHTML));
												} catch (err) {
													console.error(err);
												}
											}
										}
										m.$contents_recos = m.$contents.find(".reco");
										for (let k = 0; k < m.$contents_recos.length; k++) {
											let $reco = m.$contents_recos.eq(k);
											let recoURI = m.unescapeHTML($reco.find(".textURI").html());
											if (recoURI === uri) {
												try {
													let recoHTML = await m.recoHTML(r, false, true, false, option);
													$reco.replaceWith(String(recoHTML));
												} catch (err) {
													console.error(err);
												}
											}
										}

										await m.reNewAndReOn();
										let fs = m.fsGo;
										let fsFLUri = fs.fullList[uri];
										if (!fsFLUri) {
											fsFLUri = fs.fullList[fs.fullList.length] = fs.fullList[uri] = { uri, i: fs.fullList.length, down: false };
										}
										fsFLUri.txt = m.splitHangul(`${r?.cats} :: ${r?.title}`);
										fsFLUri.html = m.escapeOnlyTag(r?.title);
										fsFLUri[option] = true;

										let fs1 = m.fsToRs;
										let fs1FLUri = fs1.fullList[uri];
										if (!fs1FLUri) {
											fs1FLUri = fs1.fullList[fs1.fullList.length] = fs1.fullList[uri] = { uri, i: fs1.fullList.length, down: false };
										}
										fs1FLUri.txt = m.splitHangul(r?.title);
										fs1FLUri.html = m.escapeOnlyTag(r?.title);
										fs1FLUri.inRange = true;
										fs1FLUri[option] = true;
										try {
											await m.reTriggerFS(fs);
											await m.reTriggerFS(fs1);
										} catch (err) {
											console.error(err);
										}
									} else if (option === "deleted") {
										let r = m.myRecos[uri];
										r.deleted = true;
										r.has = false;
										m.$recoDeleted[m.deletedRecosCount] = m.$recoDeleted[uri] = { r, i: `deleted-${m.deletedRecosCount}` as `deleted-${number}` };
										try {
											await m.refreshFSToRs(cat);
										} catch (err) {
											console.error(err);
										}
										m.$recoms_recos = m.$contents_recoms.find(".reco");
										for (let k = 0; k < m.$recoms_recos.length; k++) {
											let $reco = m.$recoms_recos.eq(k);
											let recoURI = m.unescapeHTML($reco.find(".textURI").html());
											if (recoURI === uri) {
												try {
													let recomHTML = await m.recomHTML(r, false, option);
													// * (r, inListPlay, additionalClass)
													$reco.replaceWith(recomHTML);
													$reco.find(".button.edit").addClass("deleted");
												} catch (err) {
													console.error(err);
												}
											}
										}
										m.$contents_recos = m.$contents.find(".reco");
										for (let k = m.$contents_recos.length - 1; k >= 0; k--) {
											let $reco = m.$contents_recos.eq(k);
											let recoURI = m.unescapeHTML($reco.find(".textURI").html());
											if (recoURI === uri) {
												$reco.attr("id", `reco-deleted-${m.deletedRecosCount}`);
												let catsSplit = m.catsToString(m.fsGo.fullList[uri]?.r?.cats).split(";");
												if (!m.fsGo.fullList[uri].catAndI) {
													m.fsGo.fullList[uri].catAndI = {};
												}
												for (let i = 0; i < catsSplit.length; i++) {
													let catI = catsSplit[i];
													delete m.fsGo.fullList[uri].catAndI[catI];
												}
												m.fsGo.fullList[uri].catAndI[cat0] = { cat: cat0, i: `deleted-${m.deletedRecosCount}` };
												$reco.addClass("none deleted");
												$reco.find(".button.edit").addClass("deleted");
												m.$contents.prepend($reco[0].outerHTML);
												// ! 지우는 경우 상위로 끌어올려짐.
												$reco.remove();
											} else {
												$reco.attr("id", `reco-${m.catUriList[cat].uris[recoURI].i}`);
											}
										}

										await m.reNewAndReOn();
										let fs = m.fsGo;
										let fsFLUri = fs.fullList[uri];
										if (!fsFLUri) {
											fsFLUri = fs.fullList[uri] = { uri, has: false, down: true };
										}
										fsFLUri.uri = uri;
										fsFLUri.r = m.myRecos[uri];
										fsFLUri.has = false;
										fsFLUri.down = true;
										fsFLUri.deleted = true;

										let fs1 = m.fsToRs;
										let fs1FLUri = fs1.fullList[uri];
										if (!fs1FLUri) {
											fs1FLUri = fs1.fullList[uri] = { uri, has: false, down: true };
										}
										fs1FLUri.uri = uri;
										fs1FLUri.r = m.myRecos[uri];
										fs1FLUri.has = false;
										fs1FLUri.down = true;
										fs1FLUri.deleted = true;
										fs1FLUri.inRange = false;
										try {
											await m.reTriggerFS(fs);
											await m.reTriggerFS(fs1);
										} catch (err) {
											console.error(err);
										}

										m.deletedRecosCount++;
										m.showReco(r);
									}
								}
								m.$button_close.trigger("click");
								break;
							}
							default:
						}
					}
					await m.reNewAndReOn();

					m.fsToRs.shuffledOnce = true;
					m.fsGo.shuffledOnce = true;
					try {
						await m.reTriggerFS(m.fsToRs);
						await m.reTriggerFS(m.fsGo);
						await m.refreshFSToRs(m.currentCat);
						m.$button_close.trigger("click");
					} catch (err) {
						console.error(err);
					}
				}
				resolve();
			});
		};

		window.onpopstate = async function (e: any) {
			if (e.state) {
				m.doNotPushHistory = true;
				if (e.state.gotoCatsOn) {
					m.$goto_cats_container.show();
				} else {
					m.$goto_cats_container.hide();
				}

				if (e.state.goOn) {
					m.$fuzzy_search_container.show();
				} else {
					m.$fuzzy_search_container.hide();
				}

				if (e.state.TofROn) {
					m.$table_of_recos_container.show();
				} else {
					m.$table_of_recos_container.hide();
				}

				if (e.state.newRecoOn) {
					m.$new_reco.show();
				} else {
					m.$new_reco.hide();
				}

				if (e.state.recoMode === "multireco" && !m.$button_multireco_mode.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyM" } as any);
				} else if (e.state.recoMode === "neighbors" && !m.$button_neighbors_mode.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyB" } as any);
				} else if (e.state.recoMode === "daily-mix" && !m.$button_daily_mix.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyY" } as any);
				} else if (e.state.recoMode === "recoms" && !m.$button_get_recoms.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyR" } as any);
				} else if (e.state.recoMode === "") {
					if (m.$button_multireco_mode.hasClass("enabled")) {
						m.$window.trigger({ type: "keydown", code: "KeyM" } as any);
					} else if (m.$button_neighbors_mode.hasClass("enabled")) {
						m.$window.trigger({ type: "keydown", code: "KeyB" } as any);
					} else if (m.$button_daily_mix.hasClass("enabled")) {
						m.$window.trigger({ type: "keydown", code: "KeyY" } as any);
					} else if (m.$button_get_recoms.hasClass("enabled")) {
						m.$window.trigger({ type: "keydown", code: "KeyR" } as any);
					}
				}

				if (e.state.cat) {
					let cat = e.state.cat;
					if (cat !== m.currentCat || !m.recosShown) {
						await m.openCat(cat);
					}
				} else {
					await m.openCat("");
				}
			}
		};

		m.$def_cmd = $("#def-cmds").find(".def-cmd");
		m.$def_cmd.on("click", function (e: Event) {
			m.$input_desc.trigger("focus");
			let sStart = m.$input_desc[0].selectionStart;
			let sEnd = m.$input_desc[0].selectionEnd;
			let inputValue = m.$input_desc.val();
			let $target = $(e.target).closest(".def-cmd");
			let inserted = m.unescapeHTML($target.html() + "\n");
			m.$input_desc.val(`${inputValue.substring(0, sStart)}${inserted}${inputValue.substring(sEnd)}`);
			m.$input_desc.trigger("focus");
			sEnd = sStart + inserted.length;
			m.$input_desc[0].setSelectionRange(sEnd, sEnd);
		});
		m.$multirecoReplaceCats.on("click", function (e: Event) {
			let $this = $(e.target).closest(".def-cmd");
			let fs = m.fsMRCat;
			m.$multirecoDefCats.removeClass("selected");
			$this.addClass("selected");
			let k = fs[0].k;
			fs.catsSplit[k] = m.unescapeHTML($this.html()).trim();
			fs.$fs.val(fs.catsSplit.join(";"));
			let sStart = 0;
			for (let i = 0; i < k; i++) {
				sStart += fs.catsSplit[i].length + 1;
			}
			let sEnd = sStart + fs.catsSplit[k].length;
			fs.$fs.trigger("focus");
			fs.$fs[0].setSelectionRange(sEnd, sEnd);
		});
		m.$multirecoAddTxts.on("click", function (e: Event) {
			let $this = $(e.target).closest(".def-cmd");
			m.$multirecoDefCats.removeClass("selected");
			$this.addClass("selected");
			let sStart = m.$multireco_input_cats[0].selectionStart;
			let sEnd = m.$multireco_input_cats[0].selectionEnd;
			let inputValue = m.$multireco_input_cats.val();
			let inserted = m.unescapeHTML($this.html());
			m.$multireco_input_cats[0].value = `${inputValue.substring(0, sStart)}${inserted}${inputValue.substring(sEnd)}`;
			let l = m.$multireco_input_cats.val().length;
			m.$multireco_input_cats.trigger("focus");
			sEnd = sStart + inserted.length;
			m.$multireco_input_cats[0].setSelectionRange(sEnd, sEnd);
			m.$multireco_input_cats.trigger("keyup.fs");
		});
		m.$multirecoDeleteCat.on("click", function (e: Event) {
			let $this = $(e.target).closest(".def-cmd");
			let fs = m.fsMRCat;
			m.$multirecoDefCats.removeClass("selected");
			$this.addClass("selected");
			let k = fs[0].k;
			fs.catsSplit.splice(k, 1);
			fs.$fs.val(fs.catsSplit.join(";"));
			let sStart = 0;
			for (let i = 0; i < k; i++) {
				sStart += fs.catsSplit[i].length + 1;
			}
			let sEnd = fs.catsSplit.length === k ? sStart - 1 : sStart;
			fs.$fs.trigger("focus");
			fs.$fs[0].setSelectionRange(sEnd, sEnd);
			m.$multireco_input_cats.trigger("keyup.fs");
		});

		m.$new_reco.find("input, textarea").on("keydown.common", function (e: Event) {
			if ((e as EveEvent).code === "Escape" && m.$new_reco.is(":visible")) {
				// ESC
				m.$window.trigger({ type: "keydown", code: "KeyN" } as any);
			} else if ((e as any).ctrlKey && ((e as EveEvent).code === "Enter" || (e as EveEvent).code === "NumpadEnter")) {
				// Ctrl+Enter
				let r = m.myRecos[m.$input_uri.val().trim()];
				if (r.has) {
					m.$button_edit.trigger("click");
				} else {
					m.$button_reco.trigger("click");
				}
			}
		});
		m.input_uriOn = async function () {
			let uri = m.$input_uri.val();
			if (uri === "") {
				m.myRecos[""].cats = m.currentCat;
				m.emptifyRecoInNewReco();
			} else if (uri !== m.lastURI) {
				clearTimeout(m.setTimeoutGetAndShowDefs);
				m.setTimeoutGetAndShowDefs = setTimeout(async function () {
					await m.formatURIAndGetAndShowDefsAndRecoInNewReco(false, false);
					// * (noFormatURI, fillDefs, keepOriginal = false)
				}, m.wait);
			}
		};
		m.$input_uri.on("input.change keyup.change keydown.change cut.change paste.change click.change focus.change", m.input_uriOn);

		m.lastVal = m.val("10.0/10");
		m.$input_val_stars = $(".input-val-stars");
		m.$input_val_stars.html(m.stars(1));
		m.$input_val_stars.on("mousedown.mdInStars touchstart.mdInStars", function () {
			let $bar = m.$input_val_stars.find(".bar");
			let barW = $bar.width();
			let $val = m.$input_val;
			m.$html.on("mousemove.mdInStars touchmove.mdInStars", function (e: Event) {
				window.getSelection().removeAllRanges();
				e.preventDefault();
				e.stopPropagation();
				let x = e.type === "touchmove" ? (e as TouchEvent).touches[0].clientX : (e as MouseEvent).clientX;
				let w = x + m.$window.scrollLeft() - $bar.offset().left;
				if (w < -15) {
					w = -1;
				} else if (w < 0) {
					w = 0;
				} else if (w > m.starsWidth) {
					w = m.starsWidth;
				}
				if (w !== barW) {
					barW = w;
					if (w < 0) {
						$val.val("");
						w = 0;
					} else {
						$val.val(((w / m.starsWidth) * m.fullPts).toFixed(1) + "/" + m.fullPts);
					}
					$bar.css({ width: w });
					m.lastVal = m.val($val.val());
				}
			});
			m.$html.on("mouseup.mdInStars touchend.mdInStars", function () {
				m.$html.off("mouseup.mdInStars touchend.mdInStars mousemove.mdInStars touchmove.mdInStars");
			});
		});
		m.$input_val_stars.on("click", function (e: Event) {
			let $bar = $(e.target).find(".bar").addBack(".bar");
			let barW = $bar.width();
			let $val = m.$input_val;
			let x = e.type === "touchstart" ? (e as TouchEvent).touches[0].clientX : (e as MouseEvent).clientX;
			let w = x + m.$window.scrollLeft() - $bar.offset().left;
			if (w < 0) {
				w = 0;
			} else if (w > m.starsWidth) {
				w = m.starsWidth;
			}
			if (w !== barW) {
				$bar.css({ width: w });
				$val.val(((w / m.starsWidth) * m.fullPts).toFixed(1) + "/" + m.fullPts);
				m.lastVal = m.val($val.val());
			}
		});
		m.changeDigitAtPosition = function (part, position, change) {
			const digit = parseInt(part[position], 10);
			if (isNaN(digit)) return part;

			const newDigit = (digit + change + 10) % 10;
			return part.slice(0, position) + newDigit + part.slice(position + 1);
		};
		m.changeAtPosition = function (value, position, change) {
			let [point, maxPoint] = value.split("/");
			let [integerPart, decimalPart] = point.split(".");
			let [integerPartMax, decimalPartMax] = maxPoint.split(".");
			if (position <= integerPart.length) {
				integerPart = m.changeDigitAtPosition(integerPart, position - 1, change);
			} else if (position > integerPart.length + 1 && position <= point.length) {
				decimalPart = m.changeDigitAtPosition(decimalPart, position - integerPart.length, change);
			} else if (position > point.length + 1 && position <= point.length + 1 + integerPartMax.length) {
				integerPartMax = m.changeDigitAtPosition(decimalPartMax, position - point.length - integerPartMax.length, change);
			} else if (position > point.length + 1 + integerPartMax.length + 1) {
				decimalPartMax = m.changeDigitAtPosition(decimalPart, position - point.length - integerPartMax.length + 1, change);
			}
			return `${decimalPart ? `${integerPart}.${decimalPart}` : integerPart}/${decimalPartMax ? `${integerPartMax}.${decimalPartMax}` : integerPartMax}`;
		};
		m.$input_val.on("keydown.change-number", function (e: Event) {
			const val = (e.target as HTMLInputElement).value;
			const cursorPosition = (e.target as HTMLInputElement).selectionEnd;
			switch ((e as EveEvent).code) {
				case "Enter":
				case "NumpadEnter":
					e.preventDefault();
					break;
				case "ArrowUp":
				case "ArrowDown":
					e.preventDefault();
					e.stopPropagation();
					if (cursorPosition === 0) {
						this.setSelectionRange(cursorPosition, cursorPosition);
						return;
					}
					let numAtCursor = Number(val.charAt(cursorPosition - 1));
					if (!isNaN(numAtCursor)) {
						if ((e as EveEvent).code === "ArrowUp") {
							numAtCursor = (numAtCursor + 1) % 10;
						} else if ((e as EveEvent).code === "ArrowDown") {
							numAtCursor = (numAtCursor - 1 + 10) % 10;
						}
						const valSplit = val.split("");
						valSplit.splice(cursorPosition - 1, 1, String(numAtCursor));
						(e.target as HTMLInputElement).value = valSplit.join("");
						m.$input_val.trigger("keyup.change-point");
					}
					this.setSelectionRange(cursorPosition, cursorPosition);
					break;
				default:
			}
		});
		m.$input_val.on("input.change-point keyup.change-point keydown.change-point cut.change-point paste.change-point click.change-point focus.change-point", function (e: Event) {
			const val = m.val(this.value);
			switch ((e as EveEvent).code) {
				case "Enter":
				case "NumpadEnter":
					e.preventDefault();
					return;
				default:
			}
			if (this.value !== m.lastVal.str) {
				let $bar = $(".input-val-stars .bar");
				if (val.valid && val.str.length !== 0) {
					m.fullPts = val.divisor;
					$bar.css({ width: m.starsWidth * val.val });
				} else {
					$bar.css({ width: 0 });
				}
				m.lastVal = val;
				m.$input_val.val(val.str);
			}
		});
		m.$input_val_down = $(".input-val-down");
		m.$input_val_up = $(".input-val-up");
		m.onValDown = function () {
			let val = m.val(m.$input_val.val());
			if (val.valid) {
				if (val.val === -1) {
					m.$input_val.val("");
				} else {
					val.num -= 0.1;
					if (val.num < 0) {
						val.num = 0;
					}
					m.$input_val.val(`${val.num.toFixed(1)}/${val.divisor}`);
				}
			} else {
				m.$input_val.val("0.0/10");
			}
			m.$input_val.trigger("keyup.change-point");
		};
		m.onValUp = function () {
			let val = m.val(m.$input_val.val());
			if (val.valid) {
				if (val.val === -1) {
					m.$input_val.val("10.0/10");
				} else {
					val.num += 0.1;
					if (val.num > val.divisor) {
						val.num = val.divisor;
					}
					m.$input_val.val(`${val.num.toFixed(1)}/${val.divisor}`);
				}
			} else {
				m.$input_val.val("10.0/10");
			}
			m.$input_val.trigger("keyup.change-point");
		};
		m.$input_val_down.on("click.val-down", m.onValDown);
		m.$input_val_up.on("click.val-up", m.onValUp);
		m.$button_back.on("click", function (e) {
			m.myRecos[""].cats = m.currentCat;
			m.fillRecoInNewReco(m.myRecos[m.$input_uri.val()]);
		});

		m.closeNewReco = function () {
			if (m.$new_reco.is(":visible")) {
				m.toggleNewReco();
			}
		};
		m.reco_do = async function (args, err) {
			// * args : {strRecoDo: await m.strToJSON(`uri\tdo\tcats...\nuri0\tchange\tnew cats...`), $result, uri, cats }
			return new Promise(async (resolve, reject) => {
				if (err) {
					m.delayedLogOut(`Reco failed. ${err}`, 24 * 60 * 60, args?.$result);
					// * (msg, delayTime = 27, $result)
					m.$button_reco.removeClass("disabled");
					reject(err);
				}
				m.beInCurrentCat = false;
				args.cats = m.formatCats(args.cats);
				console.log("args.cats: ", args.cats);
				let catsSplit = args.cats.split(";");
				let k = catsSplit.length - 1;
				if (m.currentCat !== undefined) {
					for (; k >= 0; k--) {
						if (catsSplit[k] === m.currentCat) {
							m.beInCurrentCat = true;
							break;
						}
					}
				}
				let r = m.myRecos[args.uri];
				let cat = m.currentCat;
				let strRecoDoJSON = await m.strToJSON(args.strRecoDo.replace(/%20/g, "%2520"), true, true);
				const dataToSend = await m.JSONtoStr(strRecoDoJSON);
				$.ajax({
					type: "POST",
					url: "/reco/do",
					data: dataToSend,
					dataType: "text",
				})
					.fail(function () {
						clearInterval(m.setIntervalDeleyedLogOut);
						clearTimeout(m.setTimeoutDeleyedLogOut);
						m.$error.html("Reco failed.");
						args.$result?.html(m.$error.html());
						reject(m.$error.html());
					})
					.done(async function (resp) {
						clearInterval(m.setIntervalDeleyedLogOut);
						clearTimeout(m.setTimeoutDeleyedLogOut);
						let res = await m.strToJSON(resp);
						// * (str, colMap = true, rowMap = false)
						let result = res[1]?.result;
						let uri = res[1]?.uri;
						if (res[2]?.uri) {
							// * When multireco. (m.moveAllTo)
							m.$error.html(await m.arrayToTableHTML(res, true, [20, 20, 30, 30]));
							args.$result?.html(m.$error.html());
							setTimeout(function () {
								m.$error.html("");
							}, 10 * m.wait);
							let uris = ["uri"];
							for (let i = 1; i < res.length; i++) {
								let uriI = String(res[i].uri);
								uris.push(uriI);
								m.recoDowned(uriI, m.myRecos);
								m.myRecos[uriI].tLast = res[i]?.tLast;
								await m.changeCats_UriList(m.myRecos[uriI].cats, m.catsToString(args.cats), uriI);
							}
							await m.recoToEve(args.strRecoDo, m.myRecos, cat);
							setTimeout(async function () {
								m.emptifyRecoInNewReco();
								await m.refresh(m.myRecos[uris[1]].cats, "changed", uris);
								// * (cats, option, uriOrS)
								m.$button_close.trigger("click");
								resolve();
							}, m.wait);
						} else {
							m.$error.html(result);
							args.$result?.html(result);
							m.recoDowned(uri, m.myRecos);
							let cats = m.catsToString(m.myRecos[uri].cats);
							if (result.startsWith("recoed")) {
								await m.recoToEve(args.strRecoDo, m.myRecos, cat);
								if (await m.putCats_UriToLists(args.cats, uri)) {
									await m.catListToHTML();
									await m.updateCatFS();
									await m.updateGotoCatsFS();
								}
								m.myRecos[uri].tLast = res[1]?.tLast;
								setTimeout(function () {
									m.emptifyRecoInNewReco();
									console.log(`m.refresh("${cats}", "recoed", "${uri}");`);
									m.refresh(cats, "recoed", uri);
									// * (cats, option, uriOrS)
									m.$button_close.trigger("click");
									resolve();
								}, m.wait);
							} else if (result.startsWith("changed")) {
								await m.changeCats_UriList(cats, args.cats, uri);
								await m.recoToEve(args.strRecoDo, m.myRecos, m.currentCat);
								m.myRecos[uri].tLast = res[1]?.tLast;
								setTimeout(function () {
									m.emptifyRecoInNewReco();
									m.refresh(cats, "changed", uri);
									// * (cats, option, uriOrS)
									m.$button_close.trigger("click");
									resolve();
								}, m.wait);
							} else if (result.startsWith("deleted")) {
								await m.delCats_UriFromLists(cats, uri);
								setTimeout(function () {
									m.emptifyRecoInNewReco();
									m.refresh(cats, "deleted", uri);
									// * (cats, option, uriOrS)
									m.$button_close.trigger("click");
									resolve();
								}, m.wait);
							} else {
								let resTable = await m.arrayToTableHTML(res);
								m.$error.html(resTable);
								args.$result?.html(resTable);
								if (uri !== String(res[1]?.originalURI)) {
									m.$input_uri.val(uri);
									m.$input_uri.trigger("keyup.change");
								}
								reject(result);
							}
						}
					})
					.always(function () {
						m.$button_reco.removeClass("disabled");
					});
			});
		};
		m.moveAllTo = function () {
			return new Promise(async (resolve, reject) => {
				let notify = "";
				if (!m.$table_of_recos_container.is(":visible")) {
					notify += "ToR must be on.";
				}
				if (!m.$multireco_cats_container.is(":visible")) {
					notify += "\nMultireco mode must be on.";
				}
				if (!m.$table_of_recos_container.is(":visible") || !m.$multireco_cats_container.is(":visible")) {
					m.$log_out_do.html(notify.trim().replace(/\n/g, "<br/>"));
					m.$log_out_do_container.show();
					reject();
				}
				let cats = m.formatCats(m.$multireco_input_cats[0].value);
				m.$multireco_input_cats.val(cats);
				let uris = [];
				let fs = m.fsToRs;
				fs.$fsLis = fs.$fsl.find(".list-item");
				let strRecoDo = "uri\tdo\tcats";
				for (let i = fs.$fsLis.length - 1; i >= 0; i--) {
					let $liI = fs.$fsLis.eq(i);
					let uri = m.unescapeHTML($liI.find(".list-index-id").html());
					uris.push(uri);
					strRecoDo += `\n${uri}\tchange\t${cats}`;
				}
				let $result = m.$numbers_of_recos.add("#error-msg");
				let uri = m.unescapeHTML(fs.$fsLis.eq(0).find(".list-index-id").html());
				m.rmb_me(m.reco_do, { strRecoDo, $result, uri, cats });
				m.$new_reco.show();
				setTimeout(function () {
					m.$new_reco.hide();
				}, 0);
				resolve();
			});
		};
		m.$button_reco.on("click", async function () {
			m.$button_reco.addClass("disabled");
			let uri = await m.formatURIFully(m.$input_uri.val(), null, false);
			// * (uri, uriRendered, keepOriginal)
			m.$input_uri.val(uri);
			let val = m.val(m.$input_val.val().trim());
			let errorMsg = "";
			let valid = true;
			if (uri.length === 0) {
				valid = false;
				errorMsg = "URI is Empty.";
			} else if (!val.valid) {
				valid = false;
				errorMsg = "Points is of invalid form.";
			}
			if (valid) {
				let strHeads = "uri\tdo";
				let strContents = m.encloseStr(uri) + "\treco";

				let title = m.formatTitle(m.$input_title.val());
				strHeads += "\ttitle";
				strContents += "\t" + m.encloseStr(title);

				m.$input_cats.val(m.formatCats(m.$input_cats.val()));
				let cats = m.$input_cats.val();
				strHeads += "\tcats";
				strContents += "\t" + m.encloseStr(cats);

				let desc = m.descCmtRToString(m.renderStrDescCmt(m.$input_desc.val().trim()));
				strHeads += "\tdesc";
				strContents += "\t" + m.encloseStr(desc);

				let cmt = m.$input_cmt.val().trim();
				strHeads += "\tcmt";
				strContents += "\t" + m.encloseStr(cmt);

				let points = val.str;
				strHeads += "\tval";
				strContents += "\t" + m.encloseStr(points);

				let strRecoDo = strHeads + "\n" + strContents;
				m.$error.html("Being recoed...");
				m.rmb_me(m.reco_do, { strRecoDo, cats, uri }, true);
			} else {
				m.$error.html(errorMsg);
				m.$button_reco.removeClass("disabled");
			}
		});
		m.reco_change_do = function (args, err) {
			// * args : {strHeads, strContents, $result, r, uri, title, cats, desc, cmt, val}
			if (err) {
				m.$error.html(`Failed change. ${err}`);
				m.$button_edit.removeClass("disabled");
				return;
			}
			$.ajax({
				type: "POST",
				url: "/reco/do",
				data: (args.strHeads + "\n" + args.strContents).replace(/%20/g, "%2520"),
				dataType: "text",
			})
				.fail(function (resp) {
					clearInterval(m.setIntervalDeleyedLogOut);
					clearTimeout(m.setTimeoutDeleyedLogOut);
					m.$error.html("Failed change. " + resp);
				})
				.done(async function (resp) {
					clearInterval(m.setIntervalDeleyedLogOut);
					clearTimeout(m.setTimeoutDeleyedLogOut);
					let res = await m.strToJSON(resp);
					let result = res[1]?.result;
					let uri = res[1]?.uri;
					m.$error.html(m.escapeOnlyTag(result));
					console.log(res);
					if (result.startsWith("changed")) {
						let r = args.r;
						r.title = args.title;
						r.desc = args.desc;
						r.descR = m.renderStrDescCmt(args.desc);
						r.cmt = args.cmt;
						r.cmtR = m.renderStrDescCmt(args.cmt);
						r.val = args.val;
						r.tLast = res[1]?.tLast;
						await m.changeCats_UriList(r.cats, args.cats, uri);
						r.cats = args.cats;
						console.log("setTimeout( close ); triggered!");
						setTimeout(function () {
							m.emptifyRecoInNewReco();
							m.refresh(args.cats, "changed", uri);
							m.$button_close.trigger("click");
						}, m.wait);
					} else {
						m.delayedLogOut(res[1]?.result, 60 * 60 * 24, args.$result);
					}
				})
				.always(function () {
					m.$button_edit.removeClass("disabled");
				});
		};
		m.$button_edit.on("click", function (e) {
			m.$button_edit.addClass("disabled");
			let uri = m.$input_uri.val();
			let val = m.val(m.$input_val.val().trim());
			let r = m.myRecos[uri];
			if (uri.length !== 0 && val.valid && r) {
				let strHeads = "uri\tdo";
				let strContents = m.encloseStr(uri) + "\tchange";
				let changed = false;

				let title = m.formatTitle(m.$input_title.val());
				if (title !== r.title) {
					changed = true;
					strHeads += "\t" + "title";
					strContents += "\t" + m.encloseStr(title);
				}

				m.$input_cats.val(m.formatCats(m.$input_cats.val()));
				let cats = m.$input_cats.val();
				if (cats !== r.cats) {
					changed = true;
					strHeads += "\t" + "cats";
					strContents += "\t" + m.encloseStr(cats);
				}

				let desc = m.$input_desc.val().trim();
				if (desc !== r.desc) {
					changed = true;
					strHeads += "\t" + "desc";
					strContents += "\t" + m.encloseStr(desc);
				}

				let cmt = m.$input_cmt.val().trim();
				if (cmt !== r.cmt) {
					changed = true;
					strHeads += "\t" + "cmt";
					strContents += "\t" + m.encloseStr(cmt);
				}

				let points = val.str;
				if (!r.val) {
					r.val = m.val("");
				}
				if (points !== r.val.str) {
					changed = true;
					strHeads += "\t" + "val";
					strContents += "\t" + m.encloseStr(points);
				}

				if (changed) {
					m.$error.html("Being changed...");
					m.rmb_me(m.reco_change_do, { strHeads, strContents, $result: m.$error, r, uri, title, cats, desc, cmt, val }, true);
				} else {
					m.$error.html("You have made no change.");
					m.$button_edit.removeClass("disabled");
				}
			} else {
				let errorMsg = "";
				if (uri.length === 0) {
					errorMsg = "URI is Empty.";
				} else if (!val.valid) {
					errorMsg = "Points is of invalid form.";
				} else {
					errorMsg = "You have no reco on this URI.";
				}
				m.$error.html(errorMsg);
				m.$button_edit.removeClass("disabled");
			}
		});
		m.reco_delete_do = function (args, err) {
			// args : {strHeads, strContents, $result, r, uri}
			if (err) {
				m.delayedLogOut(`Failed delete. ${err}`, 60 * 60 * 24);
				m.$button_del.removeClass("disabled");
				return;
			}
			$.ajax({
				type: "POST",
				url: "/reco/do",
				data: (args.strHeads + "\n" + args.strContents).replace(/%20/g, "%2520"),
				dataType: "text",
			})
				.fail(function (resp) {
					clearInterval(m.setIntervalDeleyedLogOut);
					clearTimeout(m.setTimeoutDeleyedLogOut);
					m.$error.html("Failed delete.");
					args.$result?.html(m.$error.html());
				})
				.done(async function (resp) {
					clearInterval(m.setIntervalDeleyedLogOut);
					clearTimeout(m.setTimeoutDeleyedLogOut);
					let res = Object(await m.strToJSON(resp));
					let uri = String(res[1].uri);
					if (res[1]?.result.startsWith("deleted")) {
						m.$error.html("Deleted.");
						let cats = m.catsToString(args.r.cats);
						m.myRecos[uri].deleted = true;
						m.myRecos[uri].has = false;
						await m.delCats_UriFromLists(cats, uri);
						if (m.myPage) {
							m.$numbers_of_recos.html(`Intentionally deleted/editted reco remains in the UriLists of old cats of the reco, for a reason of easy recovery of that reco.`);
						}
						setTimeout(function () {
							m.refresh(cats, "deleted", uri);
							m.$button_close.trigger("click");
						}, m.wait);
					} else {
						m.delayedLogOut(res[1]?.result, 60 * 60 * 24, args.$result);
					}
				})
				.always(function () {
					m.$button_del.removeClass("disabled");
				});
		};
		m.$button_del.on("click", async function (e) {
			m.$button_del.addClass("disabled");
			let uri = m.$input_uri.val();
			let r = m.myRecos[uri];
			if (uri.length !== 0 && r) {
				let strHeads = "uri" + "\t" + "do";
				let strContents = m.encloseStr(uri) + "\t" + "delete";
				m.rmb_me(m.reco_delete_do, { strHeads, strContents, $result: m.$error, r, uri }, true);
			} else {
				let errorMsg = "";
				if (uri.length === 0) {
					errorMsg = "URI is required.";
				} else if (!r?.has) {
					errorMsg = "You have no reco on this URI.";
				} else {
					errorMsg = "Some error occurs.";
				}
				m.$error.html(errorMsg);
				await m.refresh(r.cats, "deleted", r.uri);
				m.$button_del.removeClass("disabled");
			}
		});

		///////////////////////////////////////////
		// Go to Cats (Somewhat different from Go, TofR)
		///////////////////////////////////////////
		m.completeCatAndOpenCat = async function (event) {
			return new Promise(async (resolve, reject) => {
				let $elem = $(event.target);
				if (!$elem.hasClass("list-item")) {
					$elem = $elem.closest(".list-item");
				}
				if (!$elem.length) {
					reject(`Out of target which does NOT have parents $(".list-item").`);
				}
				let cat = (m.currentCat = m.unescapeHTML($elem.find(".list-index-id").html()));
				let fs2 = m.fsGotoCats;
				let fsGotoCatsFLCat = fs2.fullList[cat];
				if (!fsGotoCatsFLCat) {
					// Must be there.
					let i = fs2.fullList.length;
					fsGotoCatsFLCat = fs2.fullList[i] = fs2.fullList[cat] = { cat, i, txt: m.splitHangul(cat), html: m.escapeOnlyTag(cat) };
				}
				let $catI = $(`#cat-${m.escapeEncodePctg(encodeURIComponent(cat))}`);
				if ($catI.length) {
					m.$catList.find(".cat").removeClass("selected");
					$catI.addClass("selected");
					if (m.recoMode === "" || m.recoMode === "multireco" || m.recoMode === "daily-mix") {
						$catI.find(".baseCat").addClass("down");
					}
				}
				if (m.recoMode === "" || m.recoMode === "multireco" || m.recoMode === "daily-mix") {
					fsGotoCatsFLCat.down = true;
					$elem.addClass("down");
				}
				m.$goto_cats.trigger("focus");
				for (let i = 0; i < fs2.fullList.length; i++) {
					fs2.fullList[i].selected = false;
				}
				fsGotoCatsFLCat.selected = true;
				fs2.$fsLis = fs2.$fsl.find(".list-item");
				fs2.$fsLis.removeClass("selected");
				$elem.addClass("selected");
				await m.openCat(cat);
				switch (m.recoMode) {
					case "":
						if (m.lastRecoMode === "") {
						} else if (m.lastRecoMode === "multireco") {
							m.$window.trigger({ type: "keydown", code: "KeyM" } as any);
						} else if (m.lastRecoMode === "neighbors") {
							m.$window.trigger({ type: "keydown", code: "KeyB" } as any);
						} else if (m.lastRecoMode === "recoms") {
							m.$window.trigger({ type: "keydown", code: "KeyR" } as any);
						} else if (m.lastRecoMode === "daily-mix") {
							m.$window.trigger({ type: "keydown", code: "KeyY" } as any);
						}
						m.lastRecoMode = "";
						m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
						if (!m.initialOpen || !m.initialHashURI) {
							window.location.href = `#playlist-container`;
							if (m.fsToRs.fixed) {
								m.$window.scrollTop(m.$playlist_container.offset().top - m.fsToRs.$playing.outerHeight());
							} else {
								m.$window.scrollTop(m.$playlist_container.offset().top);
							}
						}
						break;
					case "multireco":
						m.$button_multireco_mode.addClass("enabled");
						m.$contents.addClass("multireco");
						m.$multireco_cats_container.show();
						if (!m.catsContainsAllAnotCats(m.$multireco_input_cats[0].value, m.currentCat)) {
							m.$multireco_input_cats.val(m.currentCat);
						}
						if (m.lastRecoMode === "daily-mix") {
							m.refreshFSToRs(m.currentCat);
						}
						m.lastRecoMode = m.recoMode;
						m.$window.trigger({ type: "keydown", code: "KeyX" } as any);
						break;
					case "neighbors":
						m.$button_neighbors_mode.addClass("enabled");
						m.$window.trigger({ type: "keydown", code: "KeyX" } as any);
						break;
					case "recoms":
						m.$button_get_recoms.addClass("enabled");
						if (!m.initialOpen || !m.initialHashURI) {
							m.goDirectlyToHash("button-get-recoms");
						}
						break;
					case "daily-mix":
						m.$button_daily_mix.addClass("enabled");
						m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
						break;
				}
				m.fsScrollToSelected(fs2, $elem);
				if (!m.initialOpen && !m.doNotPushHistory) {
					window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
				}
				m.doNotPushHistory = false;
				resolve();
			});
		};
		m.triggerOpenCat = function (event) {
			return new Promise((resolve, reject) => {
				let $elem = $(event.target);
				if (!($elem.hasClass("baseCat") || $elem.hasClass("move-cat"))) {
					$elem = $elem.closest(".baseCat, .change-cat");
				}
				if (!$elem.length) {
					return; // * Normal activities: reject("$(event.target) is NOT [.baseCat] or [.change-cat].");
				}
				let cat = m.unescapeHTML($elem.find(".list-index-id").html());
				if ((event as EveEvent)?.which === 2) {
					// wheel click
					event.preventDefault();
					event.stopPropagation();
					window.open(m.pathOfCat(cat, m.recoMode, null, m.hashURI, m.args), "_blank");
					return resolve(false);
				} else if ((event as EveEvent)?.which === 1) {
					// left normal click
					event.preventDefault();
					event.stopPropagation();
					if (cat !== m.currentCat || m.recoMode === "recoms" || m.recoMode === "neighbors") {
						m.recosShown = false;
						m.fsToRs.shuffled = null;
					}
					m.doNotPushHistory = false;
					const fs2 = m.fsGotoCats;
					let fsFLCat = fs2.fullList[cat];
					if (!fsFLCat) {
						let i = fs2.fullList.length;
						fsFLCat = fs2.fullList[i] = fs2.fullList[cat] = { i, cat, txt: m.splitHangul(cat), html: m.escapeOnlyTag(cat) };
					}
					let k = fsFLCat.i;
					let $gotoCatsK = $(`#gotoCats-${k}`);
					if ($gotoCatsK.length) {
						$gotoCatsK.trigger("click");
						return resolve(false);
					} else {
						try {
							(function () {
								return new Promise((resolve, reject) => {
									fs2.$fsl.prepend(`<div class="list-item${fsFLCat?.down ? " down" : ""}${fsFLCat?.deleted ? " deleted" : ""}" id="gotoCats-${k}"><span class="list-index-id">${m.escapeOnlyTag(cat)}</span><span class="list-index">${k}</span>${fs2.fullList[k].html}</div>`);
									return resolve(false);
								});
							})()
								.catch((err) => {
									console.error(err);
								})
								.finally(() => {
									$gotoCatsK = $(`#gotoCats-${k}`);
									$gotoCatsK.trigger("click");
									return resolve(false);
								});
						} catch (err) {
							console.error(err);
						}
					}
				}
				resolve(false);
			});
		};

		m.$fuzzy_search.on("keydown.fs", function (e: Event) {
			m.onKeydownInFS0(e, "G", m.fsGo);
		});
		m.showAndScrollTo = function ($recoElem) {
			if ($recoElem?.length) {
				if (!$recoElem.is(":visible")) {
					$recoElem.removeClass("none");
					$recoElem.show();
				}
				let hIID = $recoElem[0].id;
				m.hashURI = "";
				if ($recoElem.hasClass("reco")) {
					m.hashURI = m.unescapeHTML($recoElem.find(".textURI").html());
				} else if (hIID) {
					m.hashURI = hIID;
				}
				if (m.hashURI) {
					window.location.hash = `#${encodeURIComponent(m.hashURI)}`;
					if (!m.initialOpen) {
						window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
					}
				}
				m.$window.scrollTop($recoElem.offset().top);
			}
		};
		m.gotoLi = async function (event) {
			clearTimeout(m.setTimeoutGotoLi);
			if ((event as any)?.srcElement?.nodeName === "A") {
				return;
			}
			const fs = m.fsGo;
			const fs1 = m.fsToRs;
			let $elem = $(event.target);
			if (!$elem.hasClass("list-item")) {
				$elem = $elem.closest(".list-item");
			}
			console.log(`m.gotoLi(event) :: $elem.find(".list-index-id").html(): `, $elem.find(".list-index-id").html());
			const k = Number($elem.find(".list-index").html());
			const uri = m.unescapeHTML($elem.find(".list-index-id").html());
			for (let i = 0; i < fs.fullList.length; i++) {
				fs.fullList[i].selected = false;
			}
			fs.fullList[uri].selected = true;
			const fsFLUri = fs.fullList[uri];
			if (!m.initialOpen && $elem.hasClass("selected")) {
				if ($elem.hasClass("clicked-twice")) {
					fs.$fs.trigger({ type: "keydown", code: "Escape" } as any);
					fs.$fsl.find(".list-item").removeClass("clicked-twice");
				} else {
					$elem.addClass("clicked-twice");
				}
			} else {
				fs.$fsLis = fs.$fsl.find(".list-item");
				fs.$fsLis.removeClass("selected");
				$elem.addClass("selected");
			}
			m.beInCurrentCat = false;
			let catsSplit = (fsFLUri.catsSplit = m.catsToString(fsFLUri.r?.cats).split(";"));
			for (let i = catsSplit.length - 1; i >= 0; i--) {
				if (m.currentCat === catsSplit[i]) {
					m.beInCurrentCat = true;
					break;
				}
			}
			if (!m.beInCurrentCat) {
				m.currentCat = catsSplit[0];
				m.recoMode = "";
				try {
					await m.openCat(m.currentCat);
				} catch (err) {
					console.error(err);
				}
			}
			let l = fsFLUri?.catAndI?.[m.currentCat]?.i ?? fs1.fullList.length - 1;
			if (m.beInCurrentCat && l !== k) {
				console.log(`l:${l} and k:${k} are different!`);
			}
			let $recoElem = $(`#reco-${l}`);
			if ($recoElem.length) {
				m.showAndScrollTo($recoElem);
			} else if (isNaN(l)) {
				try {
					m.$contents.prepend(await m.recoHTML(m.$recoDeleted[uri]?.r));
					$recoElem = $(`#reco-${l}`);
					if ($recoElem.length) {
						m.showAndScrollTo($recoElem);
					}
				} catch (err) {
					console.error(err);
				}
			} else {
				let i = Math.floor((m.catUriList[m.currentCat].uris.length - 1 - l) / m.maxShowReco);
				try {
					$(`#load-recos-${i}`).trigger("click");
					let $recoElem = $(`#reco-${l}`);
					if ($recoElem.length) {
						m.showAndScrollTo($recoElem);
						console.log(`m.showAndScrollTo($(\`#reco-${l}\`));`);
					} else {
						if (!m.setTimeoutGotoLiCount || m.setTimeoutGotoLiCount >= 3) {
							m.setTimeoutGotoLiCount = 0;
						}
						m.setTimeoutGotoLiCount++;
						if (m.setTimeoutGotoLiCount < 3) {
							m.setTimeoutGotoLi = setTimeout(function () {
								m.gotoLi(event);
							}, m.wait);
						}
					}
				} catch (err) {
					console.error(err);
				}
			}
		};
		m.doFSGo = async function () {
			let fs = m.fsGo;
			if (fs.shuffledOnce) {
				// Because shuffledOnce. But when only saved???
				let cat = m.currentCat;
				if (!m.catUriList[cat]?.has) {
					await m.getUriList("cat\n" + (cat === "" ? "\tp" : cat));
				}
				let uris = m.catUriList[cat].uris;
				let fsFL = fs.fullList;
				for (let k = 0; k < uris.length; k++) {
					let uri = String(uris[k]);
					if (m.catUriList[cat]?.uris?.[uri]) {
						m.catUriList[cat].uris[uri].i = k;
					}
					if (!fsFL[uri]) {
						let r = m.userRecos[uri];
						fsFL[uri] = { uri, r, i: m.fsGo.fullList.length, catsSplit: m.catsToString(r?.cats).split(";"), txt: m.splitHangul(`${r?.cats} :: ${r?.title}`), html: m.escapeOnlyTag(r?.title), catAndI: {} };
					}
					if (!fsFL[uri].catAndI) {
						fsFL[uri].catAndI = {};
					}
					fsFL[uri].catAndI[cat] = { cat, i: k };
				}
			}
			let fsPtnSH = m.splitHangul(fs.$fs.val());
			if (m.$fuzzy_search.is(":visible")) {
				m.args.Go = fs.$fs.val();
				if (!m.initialOpen) {
					window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
				}
			}
			let fsRes = await m.fuzzySearch(fsPtnSH, fs);
			let sorted = fsRes.sorted;
			let str = "";
			for (let i = 0; i < sorted.length; i++) {
				let k = fsRes[sorted[i]].i;
				let fsFLk = fs.fullList[k];
				if (fsFLk) {
					str += `<div id="li-${k}" class="list-item${fsFLk.selected ? " selected" : ""}${fsFLk.r?.deleted ? " deleted" : ""}"><span class="list-index">${k}</span><span class="list-index-id">${m.escapeOnlyTag(fsFLk.r?.uri)}</span>${fsFLk.html}${fsRes[sorted[i]].highlight !== undefined ? `<div class="highlighted"><span class="maxMatchScore">${fsRes[sorted[i]].maxMatchScore}</span> :: ${fsRes[sorted[i]].highlight}</div>` : ""}</div>`;
				}
			}
			fs.$fsl.html(str);
			fs.$fsLis = fs.$fsl.find(".list-item");
			let $selected = fs.$fsLis.filter(".selected");
			if ($selected.length) {
				fs.$fsl.scrollTop($selected.offset().top - fs.$fsl.offset().top - 52);
			} else {
				fs.$fsl.scrollTop(0);
			}
		};
		m.fsGoOn = function () {
			return new Promise(async (resolve, reject) => {
				let now = Date.now();
				let passed = now - m.previous;
				if (passed > m.wait) {
					m.previous = now;
					try {
						await m.doFSGo();
					} catch (err) {
						console.error(err);
					}
					return resolve();
				} else {
					m.$fuzzy_search.off("keyup.fs cut.fs paste.fs click.fs");
					setTimeout(async function () {
						m.$fuzzy_search.on("keyup.fs cut.fs paste.fs click.fs", m.fsGoOn);
						m.previous = Date.now();
						try {
							await m.doFSGo();
						} catch (err) {
							console.error(err);
						}
						return resolve();
					}, m.wait * 1.5 - passed);
				}
			});
		};

		m.$table_of_recos.on("keydown", function (e: Event) {
			m.onKeydownInFS0(e, "T", m.fsToRs);
		});
		m.$button_save_this_order = $("#button-save-this-order");
		m.$result_of_change_order = $("#result-of-change-order");
		if (m.myPage) {
			m.$button_save_this_order.show();
			m.$button_save_this_order.on("click", function (e) {
				return new Promise(async (resolve, reject) => {
					m.$result_of_change_order.html("Changing the order of UriList.");
					m.$numbers_of_recos.html("Changing the order of UriList.");
					let uris = "";
					let fs = m.fsToRs;
					for (let i = 0; i < fs.shuffled.length; i++) {
						// Newest has the maximum index i. Newest uri to the bottom (push).
						uris += "\n" + fs.fullList[fs.shuffled[i].i]?.r?.uri;
					}
					uris = uris.trim();
					if (m.catUriList[m.currentCat].UriList.trim() === uris) {
						m.$result_of_change_order.html("UriList order is the same as before.");
						m.$numbers_of_recos.html("UriList order is the same as before.");
						reject("UriList order is the same as before.");
					} else {
						let urisReversed = (await m.strToJSON(uris, false, false))
							.reverse()
							.map((v) => m.encloseStr(v))
							.join("\n");
						// Reverse is needed.
						m.rmb_me(function (args, err) {
							$.ajax({
								type: "POST",
								url: `${m.userPath}/change-order-of-UriList?cat=${encodeURIComponent(m.currentCat)}`,
								data: urisReversed,
								dataType: "text",
							})
								.fail(function (resp) {
									m.$result_of_change_order.html(resp as unknown as string);
									reject(resp);
								})
								.done(async function (resp) {
									if (resp === "true") {
										m.$result_of_change_order.html("UriList order is changed.");
										m.$numbers_of_recos.html("UriList order is changed.");
										m.catUriList[m.currentCat].UriList = uris;
										m.catUriList[m.currentCat].uris.splice(0, m.catUriList[m.currentCat].uris.length);
										// To preserve uris[uri]={cat, i}.
										let urisSplit = uris.split("\n");
										for (let i = 0; i < urisSplit.length; i++) {
											let uri = urisSplit[i];
											m.catUriList[m.currentCat].uris[i] = uri;
											m.catUriList[m.currentCat].uris[uri].i = i;
										}
										fs.shuffled = null;
										fs.shuffledOnce = true;
										m.fsGo.shuffledOnce = true;
										m.lastRecoMode = "nothing";
										m.doNotPushHistory = true;
										m.reTriggerFS(fs);
										m.reTriggerFS(m.fsGo);
										fs.shuffledOnce = true;
										m.fsGo.shuffledOnce = true;
										await m.openCat(m.currentCat);
										return resolve(true);
									} else if (resp === "false") {
										m.$result_of_change_order.html("UriList order is NOT changed. Some error may occur.");
										m.$numbers_of_recos.html("UriList order is NOT changed. Some error may occur.");
										reject("UriList order is NOT changed. Some error may occur.");
									} else {
										m.$result_of_change_order.html(`Server error. ${resp}`);
										m.$numbers_of_recos.html(`Server error. ${resp}`);
										reject(`Server error. ${resp}`);
									}
								});
						}, {});
					}
				});
			});
		}

		////////////////////////////////////////////////////
		// SNS Sharing
		////////////////////////////////////////////////////
		m.$notify_copied = $("#notify-copied, #notify-copied-exit");
		m.$textarea_copied = $("#textarea-copied");
		m.$notify_copied.hide();
		m.$textarea_copied.on("click", function (e) {
			e.stopPropagation();
		});

		////////////////////////////////////////////////////
		// ShortKeys
		////////////////////////////////////////////////////
		m.intervalCount = {};
		m.intervalOpenCat = function (intervalId) {
			if (m.intervalCount[intervalId.toString()] === undefined) {
				m.intervalCount[intervalId.toString()] = 0;
			} else if (m.intervalCount[intervalId.toString()] > m.initialMaxTries) {
				clearInterval(intervalId);
				delete m.intervalCount[intervalId.toString()];
			}
			console.log(`intervalId: ${intervalId},\nm.intervalCount[intervalId.toString()]: ${m.intervalCount[intervalId.toString()]}`);
			m.intervalCount[intervalId.toString()]++;
			let fs = m.fsGotoCats;
			let fsGotoCatsFLCat = fs.fullList[m.currentCat];
			if (fsGotoCatsFLCat?.i || fsGotoCatsFLCat?.i === 0) {
				let $gotoCatsI = $(`#gotoCats-${fsGotoCatsFLCat.i}`);
				if (m.intervalCount[intervalId.toString()] > m.initialMaxTries) {
					clearInterval(intervalId);
					delete m.intervalCount[intervalId.toString()];
					m.$numbers_of_recos.html(`Cat=${m.escapeOnlyTag(m.currentCat)} of user=${m.escapeOnlyTag(m.userId)} may not exist.`);
					// Cat=${} of user=${} may not exist.
					console.log(`$("#gotoCats-${fsGotoCatsFLCat.i}").trigger("click") failed.`);
					if (!m.initialOpen && !m.doNotPushHistory) {
						window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
					}
					m.doNotPushHistory = false;
				}
				if ($gotoCatsI.length) {
					clearInterval(intervalId);
					m.intervalCount[intervalId.toString()] = 0;
					console.log(`$("#gotoCats-${fsGotoCatsFLCat.i}").trigger("click"); in m.recoMode: ${m.recoMode}`);
					console.log(`m.currentCat: ${m.currentCat}, fsGotoCatsFLCat: `, fsGotoCatsFLCat);
					$gotoCatsI.trigger("click");
					if (!m.initialOpen && !m.doNotPushHistory) {
						window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
					}
					m.doNotPushHistory = false;
					if (m.initialOpen) {
						m.gotoHash(m.initialHashURI);
					}
				} else if (m.intervalCount[intervalId.toString()] > m.initialMaxTries) {
					clearInterval(intervalId);
					delete m.intervalCount[intervalId.toString()];
					fs.$fsl.prepend(`<div class="list-item${fsGotoCatsFLCat?.down ? " down" : ""}${fsGotoCatsFLCat?.deleted ? " deleted" : ""}" id="gotoCats-${fsGotoCatsFLCat.i}"><span class="list-index-id">${m.escapeOnlyTag(m.currentCat)}</span><span class="list-index">${fsGotoCatsFLCat.i}</span>${fsGotoCatsFLCat.html}</div>`);
					$gotoCatsI = $(`#gotoCats-${fsGotoCatsFLCat.i}`);
					$gotoCatsI.trigger("click");
					console.log(`$("#gotoCats-${fsGotoCatsFLCat.i}").trigger("click"); in m.recoMode: ${m.recoMode}`);
					console.log(`m.currentCat: ${m.currentCat}, fsGotoCatsFLCat: `, fsGotoCatsFLCat);
					if (!m.initialOpen && !m.doNotPushHistory) {
						window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
					}
					m.doNotPushHistory = false;
					if (m.initialOpen) {
						m.gotoHash(m.initialHashURI);
					}
				}
				if (m.recoMode === "" || m.recoMode === "multireco" || m.recoMode === "daily-mix") {
					m.recosShown = true;
				} else {
					m.recosShown = false;
				}
			}
		};
		m.$block_touch_exit.on("click", function (event) {
			m.$block_touch.hide();
			m.$block_touch_exit.hide();
			m.$floating_key.show();
			m.$button_block_touch.removeClass("enabled");
		});
		m.$block_touch.on("click dblclick touch mousedown touchstart mousemove touchmove mouseup touchend scroll keydown keypress keyup input select", function (e) {
			e.stopPropagation();
			e.preventDefault();
		});
		m.$fdList = $("#right-top-log-in, #change-style, #foot, #head, #headPlay, #playlist-container, .numbers-of-recos, .reco, .to-be-executed");
		// Ordered automatically by jQuery.
		m.zIndex = 10010;
		m.processShortKey = function (e: KeyboardEvent | any) {
			if (e.altKey || e.ctrlKey || e.metaKey) {
				return;
			}
			switch (e.target.nodeName) {
				case "INPUT":
				case "SELECT":
				case "TEXTAREA":
					return;
			}
			switch (e.code) {
				case "KeyZ": // * Z: To List Play
					if (!m.initialOpen || !m.initialHashURI) {
						m.goDirectlyToHash("headPlay");
					}
					break;
				case "KeyX": // * X: To contents
					if (!m.initialOpen || !m.initialHashURI) {
						m.goDirectlyToHash("numbers-of-recos");
					}
					break;
				case "KeyQ": // * Q: Preceding
					m.fsToRs.playNext(1, false, false, true);
					break;
				case "KeyW": // * W: Following
					m.fsToRs.playNext(-1, false, false, true);
					break;
				case "KeyS": // * S: Sorting
					m.$sort_list.toggle();
					break;
				case "KeyH": // * H: Shuffle
					m.$button_shuffle.trigger("click");
					break;
				case "KeyK": // * K: Auto skip
					if (m.$button_auto_skip.hasClass("enabled")) {
						m.$button_auto_skip.removeClass("enabled");
						m.fsToRs.skip = false;
						m.docCookies.removeItem("auto_skip", "/", false, true);
					} else {
						m.$button_auto_skip.addClass("enabled");
						m.fsToRs.skip = true;
						m.docCookies.setItem("auto_skip", "true", Infinity, "/", false, true);
					}
					break;
				case "KeyL": // * L: Loop
					if (m.$button_loop.hasClass("enabled")) {
						m.$button_loop.removeClass("enabled");
						m.fsToRs.loop = false;
						m.docCookies.removeItem("loop", "/", false, true);
					} else {
						m.$button_loop.addClass("enabled");
						m.fsToRs.loop = true;
						m.docCookies.setItem("loop", "true", Infinity, "/", false, true);
					}
					break;
				case "KeyP": // * P: One loop
					if (m.$button_one_loop.hasClass("enabled")) {
						m.$button_one_loop.removeClass("enabled");
						m.fsToRs.oneLoop = false;
						m.docCookies.removeItem("one_loop", "/", false, true);
					} else {
						m.$button_one_loop.addClass("enabled");
						m.fsToRs.oneLoop = true;
						m.docCookies.setItem("one_loop", "true", Infinity, "/", false, true);
					}
					break;
				case "KeyE": // * E: Expand/Hide floating keys
					m.toggleFK();
					break;
				case "KeyA": // * A: To my page
					if (!m.myPage && m.myIndex) {
						window.location.href = m.pathOfNeighbor(m.myId, m.currentCat, m.recoMode, null, m.hashURI, m.args);
					}
					break;
				case "KeyU": // * U: Block touch
					if (m.$button_block_touch.hasClass("enabled")) {
						m.$block_touch.hide();
						m.$block_touch_exit.hide();
						m.$floating_key.show();
						m.$button_block_touch.removeClass("enabled");
					} else {
						m.$block_touch.show();
						m.$block_touch_exit.show();
						m.$floating_key.hide();
						m.$button_block_touch.addClass("enabled");
					}
					break;
				case "KeyC": // * C: Go to Cats
					e.preventDefault();
					if (m.$goto_cats_container.is(":visible")) {
						m.$goto_cats_container.hide();
						m.$out_focus.trigger("focus");
						m.$button_goto_cats.removeClass("enabled");
						m.gotoCatsOn = false;
						delete m.args.GoToCats;
						if (!m.initialOpen && !m.doNotPushHistory) {
							window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
						m.doNotPushHistory = false;
					} else {
						m.$goto_cats_container.show();
						m.fsScrollToSelected(m.fsGotoCats, m.fsGotoCats.$fsl.find(".selected"));
						m.$goto_cats_container.css({ zIndex: ++m.zIndex });
						m.$goto_cats.trigger("focus");
						m.$button_goto_cats.addClass("enabled");
						m.gotoCatsOn = true;
						m.args.GoToCats = m.$goto_cats.val();
						if (!m.initialOpen && !m.doNotPushHistory) {
							window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
						m.doNotPushHistory = false;
					}
					break;
				case "KeyG": // * G: Go (FS)
					e.preventDefault();
					if (m.$fuzzy_search_container.is(":visible")) {
						m.$fuzzy_search_container.hide();
						m.$out_focus.trigger("focus");
						m.$button_Go.removeClass("enabled");
						m.goOn = false;
						delete m.args.Go;
						if (!m.initialOpen && !m.doNotPushHistory) {
							window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
						m.doNotPushHistory = false;
					} else {
						m.$fuzzy_search_container.show();
						m.fsScrollToSelected(m.fsGo, m.fsGo.$fsl.find(".selected"));
						m.$fuzzy_search_container.css({ zIndex: ++m.zIndex });
						m.$fuzzy_search.trigger("focus");
						m.$button_Go.addClass("enabled");
						m.goOn = true;
						m.args.Go = m.$fuzzy_search.val();
						if (!m.initialOpen && !m.doNotPushHistory) {
							window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
						m.doNotPushHistory = false;
					}
					break;
				case "KeyT": // * T: Table of Recos
					e.preventDefault();
					if (m.$table_of_recos_container.is(":visible")) {
						m.$table_of_recos_container.hide();
						m.$out_focus.trigger("focus");
						m.$button_ToR.removeClass("enabled");
						m.TofROn = false;
						delete m.args.TofR;
						if (!m.initialOpen && !m.doNotPushHistory) {
							window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
						m.doNotPushHistory = false;
					} else {
						m.$table_of_recos_container.show();
						m.fsScrollToSelected(m.fsToRs, m.fsToRs.$fsl.find(".selected"));
						m.$table_of_recos_container.css({ zIndex: ++m.zIndex });
						m.$table_of_recos.trigger("focus");
						m.$button_ToR.addClass("enabled");
						m.TofROn = true;
						m.args.TofR = m.$table_of_recos.val();
						if (!m.initialOpen && !m.doNotPushHistory) {
							window.history.pushState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
						m.doNotPushHistory = false;
					}
					break;
				case "KeyB": // * B: Neighbors
					e.preventDefault();
					m.$contents.removeClass("multireco");
					m.$contents.html(`<div class="loading"><div class="outerCircle"></div><div class="innerCircle"></div></div>`);
					if (m.$button_neighbors_mode.hasClass("enabled")) {
						m.recoMode = "";
						m.$button_neighbors_mode.removeClass("enabled");
					} else {
						m.recoMode = "neighbors";
						m.$button_mode.removeClass("enabled");
						m.$button_neighbors_mode.addClass("enabled");
					}
					clearInterval(m.initialFsGotoCats1);
					m.initialFsGotoCats1 = undefined;
					m.initialFsGotoCats1 = setInterval(function () {
						m.intervalOpenCat(m.initialFsGotoCats1);
					}, m.wait);
					break;
				case "KeyM": // * M: Multireco
					e.preventDefault();
					if (m.$button_multireco_mode.hasClass("enabled")) {
						m.recoMode = "";
						m.$multireco_cats_container.hide();
						m.$button_multireco_mode.removeClass("enabled");
					} else {
						m.recoMode = "multireco";
						m.$multireco_cats_container.show();
						m.$multireco_cats_container.css({ zIndex: ++m.zIndex });
						m.$button_mode.removeClass("enabled");
						m.$button_multireco_mode.addClass("enabled");
					}
					if (!m.recosShown) {
						m.$contents.html(`<div class="loading"><div class="outerCircle"></div><div class="innerCircle"></div></div>`);
					}
					clearInterval(m.initialFsGotoCats1);
					m.initialFsGotoCats1 = setInterval(function () {
						m.intervalOpenCat(m.initialFsGotoCats1);
					}, m.wait);
					break;
				case "KeyY": // * Y: Daily mix
					if (m.myPage) {
						e.preventDefault();
						if (m.$button_daily_mix.hasClass("enabled")) {
							m.recoMode = "";
							m.$button_daily_mix.removeClass("enabled");
							// m.$contents_recoms.html("");
						} else {
							m.recoMode = "daily-mix";
							m.$button_mode.removeClass("enabled");
							m.$button_daily_mix.addClass("enabled");
							// m.$contents_recoms.hide();
						}
						clearInterval(m.initialFsGotoCats1);
						m.initialFsGotoCats1 = undefined;
						m.initialFsGotoCats1 = setInterval(function () {
							m.intervalOpenCat(m.initialFsGotoCats1);
						}, m.wait);
					}
					break;
				case "KeyR": // * R: Get Recoms
					if (m.myPage) {
						e.preventDefault();
						if (m.$button_get_recoms.hasClass("enabled")) {
							m.recoMode = "";
							m.$contents_recoms.html("");
							m.$button_get_recoms.removeClass("enabled");
						} else {
							m.recoMode = "recoms";
							m.$contents_recoms.html(`<div class="loading"><div class="outerCircle"></div><div class="innerCircle"></div></div>`);
							m.$button_mode.removeClass("enabled");
							m.$button_get_recoms.addClass("enabled");
						}
						clearInterval(m.initialFsGotoCats1);
						m.initialFsGotoCats1 = undefined;
						m.initialFsGotoCats1 = setInterval(function () {
							m.intervalOpenCat(m.initialFsGotoCats1);
						}, m.wait);
					}
					break;
				case "KeyN": // * N: New reco
					e.preventDefault();
					m.toggleNewReco();
					break;
				case "KeyF": // * F: Forward
				case "KeyD": // * D: Backward
					let scrollTop = m.$window.scrollTop();
					let i,
						k = m.$fdList.length;
					let $hI;
					if (e.code === "KeyF") {
						// * F
						scrollTop += 25;
						for (i = 0; i < k; i++) {
							$hI = m.$fdList.eq(i);
							let hIID = $hI[0].id;
							if (hIID.startsWith("load-recos-")) {
								if ($hI.is(":visible") && scrollTop + m.$window.height() < $hI.offset().top) {
									break;
								}
							}
							if ($hI.is(":visible") && scrollTop < $hI.offset().top) {
								break;
							}
						}
						if (i === k) {
							return;
						}
					} else {
						// * D
						scrollTop -= 25;
						for (i = k - 1; i >= 0; i--) {
							$hI = m.$fdList.eq(i);
							if ($hI.is(":visible") && scrollTop > $hI.offset().top) {
								break;
							}
						}
						if (i === -1) {
							return;
						}
					}
					let hIID = $hI[0].id;
					if ($hI.hasClass("reco")) {
						m.hashURI = m.unescapeHTML($hI.find(".textURI").html());
						window.location.hash = `#${encodeURIComponent(m.hashURI)}`;
						m.$window.scrollTop($hI.offset().top);
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					} else if (hIID) {
						m.hashURI = hIID;
						if (e.code === "KeyF" && hIID.startsWith("load-recos-")) {
							// * F
							m.$window.scrollTop($hI.offset().top - (m.$window.height() * 2.0) / 3.0);
						} else {
							// * F (normal) and * D
							m.$window.scrollTop($hI.offset().top);
						}
						if (!m.initialOpen) {
							window.history.replaceState({ cat: m.currentCat, mode: m.recoMode, gotoCatsOn: m.gotoCatsOn, goOn: m.goOn, TofROn: m.TofROn, newRecoOn: m.newRecoOn }, "", m.pathOfCat(m.currentCat, m.recoMode, null, m.hashURI, m.args));
						}
					}
					break;
				case "KeyI": // * I: Log in
					m.$a_log_in.trigger("click");
					break;
				case "KeyO": // * O: Log out
					m.$a_log_out.trigger("click");
					break;
				default:
					break;
			}
		};
		m.$window.on("keydown.sk", m.processShortKey);

		m.$shortkeyDesc = $("ul#shortkeys");
		if (m.$shortkeyDesc.length) {
			m.$shortkeyDesc.html(
				`<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyC' })"><span class="bold">C</span>: Go to <span class="bold underline">C</span>ats</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyG' })"><span class="bold">G</span>: Fuzzy Search <span class="bold underline">G</span>o (FS)</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyT' })"><span class="bold">T</span>: Table of Recos <span class="bold underline">T</span>ofR</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyZ' })"><span class="bold">Z</span>: To List Play(<span class="bold underline">Z</span>)</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyX' })"><span class="bold">X</span>: To Contents(<span class="bold underline">X</span>)</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyF' })"><span class="bold">F</span>: <span class="bold underline">F</span>orward</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyD' })"><span class="bold">D</span>: Backwar<span class="bold underline">d</span></span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyN' })"><span class="bold">N</span>: <span class="bold underline">N</span>ew reco</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyM' })"><span class="bold">M</span>: <span class="bold underline">M</span>ultireco mode</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyB' })"><span class="bold">B</span>: Neigh<span class="bold underline">b</span>ors mode</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyR' })"><span class="bold">R</span>: Get <span class="bold underline">R</span>ecoms</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyY' })"><span class="bold">Y</span>: Dail<span class="bold underline">y</span> Mix Recoms with ToR</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyU' })"><span class="bold">U</span>: Block to<span class="bold underline">u</span>ch</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyI' })"><span class="bold">I</span>: Log <span class="bold underline">i</span>n</span></li>
		<li><span onclick="m.$window.trigger({ type: 'keydown', code: 'KeyO' })"><span class="bold">O</span>: Log <span class="bold underline">o</span>ut</span></li>`,
			);
		}
		m.$shortkeyDesc.hide();
		m.toggleShortkeyDesc = function () {
			if (m.$shortkeyDesc.is(":visible")) {
				m.$shortkeyDesc.hide();
				m.$button_toggle_shortkey_desc.removeClass("enabled");
			} else {
				m.$shortkeyDesc.show();
				m.$button_toggle_shortkey_desc.addClass("enabled");
			}
		};
		m.$shortkeyDesc.before(`<div class="button" id="button-toggle-shortkey-desc" onclick="m.toggleShortkeyDesc()">Toggle ShortKey Description</div>`);
		m.$button_toggle_shortkey_desc = $("#button-toggle-shortkey-desc");

		////////////////////////////////////////////////
		// Initial open :: Lang : set cookie, Cat : get and show recos
		////////////////////////////////////////////////
		m.$document.ready(async function () {
			await m.reNewFSsOn();

			setTimeout(function () {
				let blogStat = `URI\treferer\tREACTION_GUEST\n${window.location.href}\t${document.referrer}\t${m.myId}`;
				$.ajax({
					type: "POST",
					url: "/BlogStat",
					data: blogStat,
					dataType: "text",
				})
					.fail(function (resp) {
						console.log("BlogStat:", resp);
						console.log(blogStat);
						m.finalizeInitialOpen();
					})
					.done(function (resp) {
						console.log("BlogStat:", resp);
						console.log(blogStat);
						m.finalizeInitialOpen();
					});
			}, 8 * m.wait);

			let vars = m.searchVars;
			// At the first script.
			let cat = m.currentCat;
			// At the first script.
			let uri = m.localStorage.getItem("uri");
			if (vars?.uri?.val) {
				m.$input_uri.val(vars.uri.val);
			} else if (uri && uri !== "null") {
				m.$input_uri.val(uri);
			}
			uri = m.$input_uri.val();
			if (uri !== m.lastURI) {
				m.lastURI = uri;
				await m.formatURIAndGetAndShowDefsAndRecoInNewReco(false, false);
				// * (noFormatURI, fillDefs, keepOriginal = false)
				await m.reNewAndReOn();
			} // If there is m.myRecos[uri], fill #new-reco inputs with it. But if there is saved revision, fill revised versions to #new-reco inputs.
			// m.currentCat = "";
			// TODO: remove this.
			m.initialFillFromLocalStorageN = 0;
			m.initialFillFromLocalStorage = setInterval(function () {
				let title = m.localStorage.getItem("title");
				let changed = false;
				if (vars?.title?.val) {
					changed = changed || m.$input_title.val() !== vars.title.val;
					m.$input_title.val(vars.title.val);
				} else if (title && title !== "null") {
					changed = changed || m.$input_title.val() !== title;
					m.$input_title.val(title);
				}
				let cats = m.localStorage.getItem("cats");
				if (vars?.cats?.val) {
					cats = m.formatCats(vars.cats.val);
					changed = changed || m.$input_cats.val() !== cats;
					m.$input_cats.val(cats);
				} else if (cats && cats !== "null") {
					cats = m.formatCats(cats);
					changed = changed || m.$input_cats.val() !== cats;
					m.$input_cats.val(cats);
				}
				if (vars?.cat?.val) {
					cat = m.currentCat = vars.cat.val;
				} else if (cats && cats !== "null") {
					changed = changed || !m.catsContainsAllAnotCats(cats, m.currentCat);
					if (!m.catsContainsAllAnotCats(cats, m.currentCat)) {
						cat = m.currentCat = cats.split(";")[0].trim();
					}
				}
				let desc = m.localStorage.getItem("desc");
				if (desc && desc !== "null") {
					changed = changed || m.$input_desc.val() !== desc;
					m.$input_desc.val(desc);
				}
				let cmt = m.localStorage.getItem("cmt");
				if (cmt && cmt !== "null") {
					changed = changed || m.$input_cmt.val() !== cmt;
					m.$input_cmt.val(cmt);
				}
				let points = m.localStorage.getItem("points");
				if (points && points !== "null") {
					changed = changed || m.$input_val.val() !== points;
					m.$input_val.val(points);
					m.$input_val.trigger("keyup.change-point");
				}
				if (!changed) {
					m.initialFillFromLocalStorageN++;
				}
				console.log(`m.initialFillFromLocalStorageN: ${m.initialFillFromLocalStorageN};`);
				if (!changed && m.initialFillFromLocalStorageN > m.initialMaxTries) {
					clearInterval(m.initialFillFromLocalStorage);
					m.initialFillFromLocalStorageN = 0;
				}
			}, m.wait);

			if (vars.timezone) {
				let timezone = vars.timezone;
				m.docCookies.setItem("timezone", timezone, Infinity, "/", false, true);
				m.setTimezone(null, timezone);
				m.$search_timezone.val(timezone);
			} else if (m.docCookies.hasItem("timezone")) {
				let timezone = m.docCookies.getItem("timezone");
				m.setTimezone(null, timezone);
				m.$search_timezone.val(timezone);
			}

			if (vars.PRL || vars.PRR) {
				if (vars.PRL) {
					let val = vars.PRL.val;
					m.args.PRL = val;
					m.ptsRangeFrom = Number(Number(val).toFixed(2));
					m.docCookies.setItem("PRL", val, Infinity, "/", false, true);
				} else {
					m.ptsRangeFrom = 0;
					m.docCookies.setItem("PRL", "0", Infinity, "/", false, true);
				}
				if (vars.PRR) {
					let val = vars.PRR.val;
					m.args.PRR = val;
					m.ptsRangeTo = Number(Number(val).toFixed(2));
					m.docCookies.setItem("PRR", val, Infinity, "/", false, true);
				} else {
					m.ptsRangeTo = 1;
					m.docCookies.setItem("PRR", "1", Infinity, "/", false, true);
				}
			} else {
				if (m.docCookies.hasItem("PRL")) {
					m.ptsRangeFrom = Number(m.docCookies.getItem("PRL"));
				} else {
					m.ptsRangeFrom = 0;
					m.docCookies.setItem("PRL", "0", Infinity, "/", false, true);
				}
				if (m.docCookies.hasItem("PRR")) {
					m.ptsRangeTo = Number(m.docCookies.getItem("PRR"));
				} else {
					m.ptsRangeTo = 1;
					m.docCookies.setItem("PRR", "1", Infinity, "/", false, true);
				}
			}
			m.PRw = m.$point_range.width();
			m.PRLw = m.ptsRangeFrom * m.PRw;
			m.$point_range_left.css({ left: `calc(${(m.PRLw / m.PRw) * 100}% - 23px)` });
			m.$point_range_bar.css({ left: `${(m.PRLw / m.PRw) * 100}%` });
			m.PRRw = m.ptsRangeTo * m.PRw;
			m.$point_range_right.css({ right: `calc(${100 - (m.PRRw / m.PRw) * 100}% - 23px)` });
			m.$point_range_bar.css({ right: `${100 - (m.PRRw / m.PRw) * 100}%` });

			m.PRw1 = m.$point_range1.width();
			m.PRLw1 = m.ptsRangeFrom * m.PRw1;
			m.$point_range_left1.css({ left: `calc(${(m.PRLw1 / m.PRw1) * 100}% - 15px)` });
			m.$point_range_bar1.css({ left: `${(m.PRLw1 / m.PRw1) * 100}%` });
			m.PRRw1 = m.ptsRangeTo * m.PRw1;
			m.$point_range_right1.css({ right: `calc(${100 - (m.PRRw1 / m.PRw1) * 100}% - 15px)` });
			m.$point_range_bar1.css({ right: `${100 - (m.PRRw1 / m.PRw1) * 100}%` });

			m.$point_range_result.html((m.ptsRangeFrom * m.PRmax).toFixed(1) + "~" + (m.ptsRangeTo * m.PRmax).toFixed(1) + " / " + m.PRmax);

			if (m.docCookies.hasItem("auto_skip")) {
				if (m.docCookies.getItem("auto_skip") === "true" && !m.$button_auto_skip.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyK" } as any);
				}
			}
			if (m.docCookies.hasItem("loop")) {
				if (m.docCookies.getItem("loop") === "true" && !m.$button_loop.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyL" } as any);
				}
			}
			if (m.docCookies.hasItem("one_loop")) {
				if (m.docCookies.getItem("one_loop") === "true" && !m.$button_one_loop.hasClass("enabled")) {
					m.$window.trigger({ type: "keydown", code: "KeyP" } as any);
				}
			}

			if (m.lastRecoMode !== m.recoMode) {
				if (m.recoMode === "") {
					m.$button_mode.removeClass("enabled");
					m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
					clearInterval(m.initialFsGotoCats0);
					m.initialFsGotoCats0 = setInterval(function () {
						m.intervalOpenCat(m.initialFsGotoCats0);
					}, m.wait);
				} else if (m.recoMode === "multireco") {
					m.$window.trigger({ type: "keydown", code: "KeyM" } as any);
				} else if (m.recoMode === "neighbors") {
					m.$window.trigger({ type: "keydown", code: "KeyB" } as any);
				} else if (m.recoMode === "recoms") {
					m.$window.trigger({ type: "keydown", code: "KeyR" } as any);
				} else if (m.recoMode === "daily-mix") {
					m.$window.trigger({ type: "keydown", code: "KeyY" } as any);
				}
				m.lastRecoMode = m.recoMode;
			}

			if (vars?.TofR?.val || vars?.TofR?.val === "") {
				m.$table_of_recos.val(vars.TofR.val);
				if (!m.$table_of_recos_container.is(":visible")) {
					m.$window.trigger({ type: "keydown", code: "KeyT" } as any);
				}
			}
			if (vars?.Go?.val || vars?.Go?.val === "") {
				m.$fuzzy_search.val(vars.Go.val);
				if (!m.$fuzzy_search_container.is(":visible")) {
					m.$window.trigger({ type: "keydown", code: "KeyG" } as any);
				}
			}

			if (m.initialPathname === "/reco") {
				m.$button_new_reco.addClass("enabled");
				m.$input_uri[0].disabled = false;
				if (!m.$new_reco.is(":visible")) {
					m.$new_reco.show();
				}
				if (cat && (m.$input_cats.val().trim() === "" || m.$input_uri.val().trim() === "")) {
					m.$input_cats.val(cat);
				}
				m.wST = m.$window.scrollTop();
				m.$window.off("scroll.stop");
				m.$window.on("scroll.stop", function (e) {
					e.preventDefault();
					e.stopPropagation();
					m.$window.scrollTop(m.wST);
				});
				m.$input_title.trigger("focus");
				if (m.myIndex) {
					m.$input_uri.trigger("keyup.change");
				} else {
					m.gotoLogIn = function (e) {
						let path = `/account/log-in?goto=${encodeURIComponent(m.initialPathname + m.initialSearch + (m.initialHashURI ? `#${encodeURIComponent(m.initialHashURI)}` : ""))}`;
						if ((e as EveEvent)?.which === 2) {
							// wheel click.
							window.open(path, "_blank");
						} else {
							window.location.href = path;
						}
						return false;
					};
					$("#log-out-do-container>.center").html(`You should <a class="goto-current-page" onclick="return m.gotoLogIn(this)" target="_blank" href="/account/log-in?goto=${encodeURIComponent(m.initialPathname + m.initialSearch + "#" + encodeURIComponent(m.initialHashURI))}">log-in | sign-up</a> first with remember me option.`);
					$("#log-out-do-container, #log-out-do-exit").show();
				}
			}
			m.$title.html(`${m.userId}'s recoeve.net`);
			m.gotoHash(m.initialHashURI);
			m.$goto_cats_container.hide();
			if (!m.initialHashURI) {
				m.$window.trigger({ type: "keydown", code: "KeyZ" } as any);
			}
			if (m.docCookies.getItem("hideFK") === "y") {
				m.$floating_key.hide();
			}
			if (m.docCookies.getItem("hideManual") === "n") {
				if (!m.$recoeve_manual.is(":visible")) {
					m.toggleManual();
				}
			}
		});

		m.$toggle_reco_list_play.on("mouseenter", function (e) {
			m.$toggle_reco_list_play.html(`▼ Toggle reco list play`);
		});
		m.$toggle_reco_list_play.on("mouseleave", function (e) {
			if (m.$uri_rendered_container.is(":visible")) {
				m.$toggle_reco_list_play.html(`▼ Showing reco list play`);
			} else {
				m.$toggle_reco_list_play.html(`▼ Hiding reco list play`);
			}
		});
		m.fsToRs.toggleRecoListPlay = function () {
			if (m.$uri_rendered_container.is(":visible")) {
				m.$uri_rendered_container.hide();
				m.$toggle_reco_list_play.removeClass("enabled");
				m.$toggle_reco_list_play.html(`▼ Hiding reco list play`);
			} else {
				m.$uri_rendered_container.show();
				m.$toggle_reco_list_play.addClass("enabled");
				m.$toggle_reco_list_play.html(`▼ Showing reco list play`);
			}
		};

		m.$toggle_manual = $("#toggle-manual");
		m.$recoeve_manual = $("#recoeve-manual");
		m.$toggle_manual.on("mouseenter", function () {
			m.$toggle_manual.html(`▼ Toggle Recoeve.net Manual`);
		});
		m.$toggle_manual.on("mouseleave", function () {
			if (m.$recoeve_manual.is(":visible")) {
				m.$toggle_manual.html(`▼ Showing Recoeve.net Manual`);
			} else {
				m.$toggle_manual.html(`▼ Hiding Recoeve.net Manual`);
			}
		});
		m.toggleManual = function () {
			if (m.$recoeve_manual.is(":visible")) {
				m.$recoeve_manual.hide();
				m.$toggle_manual.removeClass("enabled");
				m.$toggle_manual.html(`▼ Hiding Recoeve.net Manual`);
				m.docCookies.removeItem("hideManual", "/", false, true);
			} else {
				m.$recoeve_manual.show();
				m.$toggle_manual.addClass("enabled");
				m.$toggle_manual.html(`▼ Showing Recoeve.net Manual`);
				m.docCookies.setItem("hideManual", "n", Infinity, "/", false, true);
			}
		};
	}

	useEffect(() => {
		(async () => {
			await initialEffect();
			await m.reNewAndReOn();
		})();
	}, []);

	return (
		<>
			<h1 id="h1" className="none">{`${m.userId}'s Recoeve.net`}</h1>
			<data id="data-myCatList"></data>
			<data id="data-catList"></data>
			<data id="data-kipid-catList"></data>
			<div id="container" className={styles.mode} style={{ fontFamily: styles.fontFamily, fontSize: (styles.fontSize).toFixed(2) + 'em', lineHeight: styles.lineHeight }}>
				<SidebarCon myCatList={myCatList} setMyCatList={setMyCatList} userCatList={userCatList} setUserCatList={setUserCatList} isChangingOrder={isChangingOrder} setIsChangingOrder={setIsChangingOrder}></SidebarCon>
				<RightTop></RightTop>
				<LangList></LangList>
				<FSTimezone></FSTimezone>
				<TimezoneList></TimezoneList>
				<ChangeStyle styles={styles} setStyles={setStyles}></ChangeStyle>
				<Foot></Foot>
				<ShortKeys></ShortKeys>
				<GoogleSearch></GoogleSearch>
				<ButtonsHead></ButtonsHead>
				<ContentsRecoms></ContentsRecoms>
				<ButtonsPointRange></ButtonsPointRange>
				<HeadPlay></HeadPlay>
				<Manual></Manual>
				<div className="side2">
					<div className="numbers-of-recos" id="numbers-of-recos"></div>
				</div>
				<ContentsRecos></ContentsRecos>
				<footer className="side2" id="footage">© 2024 Recoeve.net  |  Business registration number : 404-48-00903<br/>CEO : KangSoo Lee  |  Address : Ansanchunnam-ro 265, Danwon-gu Gojan-dong, Ansan city, Kyunggi-do, South Korea</footer>
				<FSGotoCats></FSGotoCats>
				<FSGo></FSGo>
				<FSTableOfRecos></FSTableOfRecos>
				<FSMultirecoCats></FSMultirecoCats>
				<ButtonsFloating></ButtonsFloating>
				<Memorizing></Memorizing>
				<FormNewReco></FormNewReco>
				<NotiCopied></NotiCopied>
				<NotiLogOut></NotiLogOut>
				<BlockTouch blockTouch={blockTouch} setBlockTouch={setBlockTouch}></BlockTouch>
			</div>
			<div id="scripts"></div>
		</>
	);
}

export { m };
